import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { logger } from "../utils/logger";
import { removeToken } from "../utils/tokenStorage";
import { Routes, Route, useNavigate, useLocation, Link, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { BannerAtualizacao } from "@/features/atualizacao";
import { FaixaMensalidadeVencida } from "@/features/cobranca";
import { SinoNotificacoes } from "@/features/notificacoes";
import { SimuladorFlutuante } from "@/features/balanca";
import { AjudaPage } from "../features/ajuda";
import { SuporteMenu } from "../features/suporte-menu";
import { useModulosLoja } from "../features/preferencias";
import { menuAbertoInicial, menuAbertoPreferido, salvarMenuAberto } from "../features/menu-lateral";
import AvaliacaoMensal from "../components/AvaliacaoMensal";
import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "../components/icons/ModulosIcons";
import { Share2, ChefHat, Package, ShoppingCart, ShoppingBag, FileText, BarChart3, LogOut, Shield, Settings, Menu, X, ChevronDown, ChevronRight, Home, DollarSign, ClipboardList, Truck, Users, UtensilsCrossed, UserRound, MessageCircle, Building2, AlertTriangle, Wallet, Receipt, CreditCard, PieChart, Megaphone, Send, Gift, Ticket, Store, Briefcase, MapPin, Crown, Info, Download, Sun, Moon, RefreshCw, Bell, Search, LayoutGrid, Layers, Bot, Sparkles, Calendar, Pizza as PizzaIcon , LifeBuoy, Images, Landmark, Timer } from "lucide-react";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../components/ui/alert-dialog";
// DarkModeToggle movido para dropdown do perfil
import AbrirCaixaModal from "../components/modals/AbrirCaixaModal";
import FecharCaixaModal from "../components/modals/FecharCaixaModal";
import OpenStorePrompt from "../components/OpenStorePrompt";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import VisaoGeral from "./VisaoGeral";
import Reports from "./Reports";
import RelatorioVendas from "./RelatorioVendas";
import RelatorioCategorias from "./RelatorioCategorias";

// Retorna true se o item de menu ainda está dentro do período de "novidade"
// (use newUntil: 'YYYY-MM-DD' no item — ex: newUntil: '2026-07-05' = badge até essa data)
function isItemNew(item) {
  if (!item?.newUntil) return false;
  try {
    return new Date() < new Date(item.newUntil + 'T23:59:59');
  } catch { return false; }
}

// Chip com halo pulsante pra destacar itens do menu. Label e variante de cor
// vêm do item de menu (`badgeLabel`, `badgeVariant`). Default = "Novo" verde.
// Adicione novas variantes em BADGE_VARIANTS conforme necessidade.
const BADGE_VARIANTS = {
  // verde — feature totalmente nova
  new: {
    ping: "bg-emerald-400/70",
    chip: "bg-gradient-to-r from-emerald-500 to-emerald-600 shadow-emerald-500/40",
  },
  // azul — feature existente que mudou (visual, fluxo, etc)
  updated: {
    ping: "bg-sky-400/70",
    chip: "bg-gradient-to-r from-sky-500 to-blue-600 shadow-sky-500/40",
  },
  // âmbar — feature anunciada mas ainda não disponível
  soon: {
    ping: "bg-amber-400/60",
    chip: "bg-gradient-to-r from-amber-500 to-orange-600 shadow-amber-500/40",
  },
};
// Item com `comingSoon: true` no menu: exibe o badge normalmente mas NÃO
// navega — clique só avisa. A página em si continua acessível por URL direta
// como fallback (ambas já renderizam card de "Em breve").
const handleComingSoonClick = () =>
  toast.info("Em breve! Esta funcionalidade ainda está em desenvolvimento.");

const NewBadge = ({ label = "Novo", variant = "new" }) => {
  const colors = BADGE_VARIANTS[variant] || BADGE_VARIANTS.new;
  return (
    <span className="relative inline-flex items-center flex-shrink-0" title={label}>
      <span className={`absolute inset-0 rounded-full animate-ping ${colors.ping}`} aria-hidden="true" />
      <span className={`relative inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-black tracking-wider uppercase text-white shadow-md ring-1 ring-white/30 ${colors.chip}`}>
        {label}
      </span>
    </span>
  );
};
import Ingredients from "./Ingredients";
import Purchases from "./Purchases";
import NovaCompraPage from "../features/compras/nova/NovaCompraPage";
import NovaDespesaPage from "../features/despesas/nova/NovaDespesaPage";
import Products from "./Products";
import BalcaoVendas from "./BalcaoVendas";
import Mesas from "./Mesas";
import Comandas from "./Comandas";
import ChatBot from "./ChatBot";
import Delivery from "./Delivery";
import EntregadorDetalhe from "./EntregadorDetalhe";

// Wrapper SIMPLIFICADO - não ativa delivery automaticamente
// Deixar o usuário controlar qual aba está ativa
function EntregadorDetalheWrapper({ setActiveTopMenu, usingSidebarMenuRef }) {
  // REMOVIDO: Não ativar delivery automaticamente
  // Isso permite que o usuário navegue pelo menu lateral sem interferência
  // A aba delivery só será ativada se o usuário clicar manualmente na aba do top menu
  return <EntregadorDetalhe />;
}
import Clientes from "./Clientes";
import Fornecedores from "./Fornecedores";
import Funcionarios from "./Funcionarios";
import Bairros from "../features/bairros/BairrosPage";

import AreaEntrega from "./AreaEntrega";
import Pedidos from "./Pedidos";
import Despesas from "./Despesas";
import ExtratoFinanceiro from "./ExtratoFinanceiro";
import Caixa from "../features/caixa/CaixaPage";
import { permissoesCaixa } from "../features/caixa/lib/permissoes";
import KDS from "./KDS";
import IndiqueEGanhe from "./IndiqueEGanhe";
import RelatorioCashback from "./RelatorioCashback";
import RelatorioCampanhas from "./RelatorioCampanhas";
import ConfigCampanhaInteligentePage from "../features/ofertas-do-dia/admin/ConfigCampanhaInteligentePage";
import RelatorioCampanhaInteligentePage from "../features/ofertas-do-dia/admin/RelatorioCampanhaInteligentePage";
import ConfigRecuperadorPage from "../features/recuperador/ConfigRecuperadorPage";
import RelatorioRecuperadorPage from "../features/recuperador/RelatorioRecuperadorPage";
import { RelatorioTempoPage } from "../features/relatorio-tempo";
import RelatorioSugestoesPage from "../features/sugestoes/admin/RelatorioSugestoesPage";
import RelatorioCuponsPage from "../features/relatorios-ofertas/cupons/RelatorioCuponsPage";
import CupomDetalhePage from "../features/relatorios-ofertas/cupons/CupomDetalhePage";
import RelatorioMetaAdsPage from "../features/relatorios-ofertas/meta-ads/RelatorioMetaAdsPage";
import CampanhaMetaDetalhePage from "../features/relatorios-ofertas/meta-ads/CampanhaMetaDetalhePage";
import RelatorioPromocoesPage from "../features/relatorios-ofertas/promocoes/RelatorioPromocoesPage";
import RelatorioCartaoPage from "../features/relatorios-ofertas/fidelidade/RelatorioCartaoPage";
import PromocaoDetalhePage from "../features/relatorios-ofertas/promocoes/PromocaoDetalhePage";
import FormasPagamento from "./FormasPagamento";
import { EditarFormaPage } from "../features/formas-pagamento";
import { FluxoCaixaPage } from "../features/fluxo-caixa";
import RelatorioOfertas from "./RelatorioOfertas";
import RelatorioEntregas from "./RelatorioEntregas";
import Promocoes from "./Promocoes";
import Sistema from "./Sistema";
import Assinatura from "./Assinatura";
import RelatorioAvaliacoes from "./RelatorioAvaliacoes";
import CuponsDesconto from "./CuponsDesconto";
import { CartaoFidelidadePage, CashbackPage, EmBrevePage, FidelizePage } from "@/features/fidelize";
import { DisparosPage } from "@/features/disparos";
import { LinksDivulgacaoPage } from "@/features/divulgacao";
import { AnunciosMetaPage, ImpulsionarPage, ListaAvisosMeta, useAvisosMeta } from "@/features/anuncios-meta";
import { FiscalPage, FiscalProvider } from "@/features/fiscal";
import RelatorioCardapio from "./RelatorioCardapio";
import { BannersPage } from "../features/cardapio-banners";
import Campanhas from "./Campanhas";
import CardapioPublico from "./CardapioPublico";
import ConfiguracaoHorarios from "./ConfiguracaoHorarios";
import ReleaseNotesModal from "../components/ReleaseNotesModal";
import IFoodConfig from "./IFoodConfig";
import { getRequiredPlan, getTopMenuRequiredPlan, hasAccess, PlanBadge, PlanGateOverlay, getModuleLockState, getPlanLabel } from "../components/PlanGate";
import { useChamadosGarcom } from "../features/mesa-qr/useChamadosGarcom";
import ChamadoGarcomBanner from "../features/mesa-qr/ChamadoGarcomBanner";
import { ListaFilaAtendimento, useFilaAtendimento } from "../features/fila-atendimento";
import { LogoCentralCabecalho } from "../features/cabecalho-logo";
import { sincronizarTemaDoUsuario, trocarTemaDoUsuario } from "../features/tema";

// Ícone do WhatsApp customizado
const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// v1.5.362+ MVP Agendamentos: badge dinâmico com contagem de agendados
// pendentes (aprovar/recusar) + pedidos de cancelamento aguardando decisão.
// Aparece nos itens Delivery/Pedidos. Vermelho quando tem cancel pedido; amber caso contrário.
function AgendadosCountBadge({ count }) {
  const total = Number(count?.total || 0);
  if (total <= 0) return null;
  const hasCancel = Number(count?.com_cancelamento_pedido || 0) > 0;
  return (
    <span
      className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[10px] font-black tabular-nums text-white ${hasCancel ? 'bg-red-500 animate-pulse' : 'bg-amber-500'}`}
      title={hasCancel ? `${total} pendente(s) — ${count.com_cancelamento_pedido} pediu(m) cancelamento` : `${total} agendamento(s) aguardando aprovação`}
    >
      {total > 99 ? '99+' : total}
    </span>
  );
}

export default function Dashboard({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const location = useLocation();
  // Trava scroll do body/html enquanto o admin estiver montado. SPA admin não
  // deve scrollar a viewport — cada rota gerencia seu próprio scroll interno.
  // Aplicar diretamente no body é mais robusto que `overflow-hidden` em
  // wrappers React: garante 100% que nenhum conteúdo de nenhuma rota cause
  // scroll do body, sem depender de cascata de classes Tailwind sobreviver
  // até o nível raiz.
  useEffect(() => {
    const prevBody = {
      overflow: document.body.style.overflow,
      overflowX: document.body.style.overflowX,
      overflowY: document.body.style.overflowY,
    };
    const prevHtml = {
      overflow: document.documentElement.style.overflow,
      overflowX: document.documentElement.style.overflowX,
      overflowY: document.documentElement.style.overflowY,
    };
    // Set ambos os eixos explicitamente — overflow: hidden NÃO basta quando
    // algum CSS específico sobrescreve overflow-x ou overflow-y individualmente
    document.body.style.overflow = 'hidden';
    document.body.style.overflowX = 'hidden';
    document.body.style.overflowY = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    document.documentElement.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflow = prevBody.overflow;
      document.body.style.overflowX = prevBody.overflowX;
      document.body.style.overflowY = prevBody.overflowY;
      document.documentElement.style.overflow = prevHtml.overflow;
      document.documentElement.style.overflowX = prevHtml.overflowX;
      document.documentElement.style.overflowY = prevHtml.overflowY;
    };
  }, []);
  // v1.5.406: inicializa JÁ com o usuário do localStorage (lazy initializer),
  // em vez de null + useEffect. Motivo: `canAccessModule` devolve true enquanto
  // currentUser é null (fail-open pra não piscar menu vazio) — com null no
  // primeiro render, o funcionário AINDA montava a Visão Geral e disparava ~10
  // requests pesados antes do guard agir. Lendo aqui, o primeiro render já sabe
  // quem é. Sem "user" no localStorage segue null, preservando o fail-open.
  const [currentUser, setCurrentUser] = useState(() => {
    try {
      const u = localStorage.getItem("user");
      return u ? JSON.parse(u) : null;
    } catch (_) {
      return null;
    }
  });
  // Desktop: nasce como o usuário deixou (botão ☰); celular segue aberto como sempre.
  // Telas de operação (Mesas, Comandas, Balcão, Delivery, Totem) ocupam a tela
  // toda e o menu fica por cima: abrindo direto nelas (link, F5) ele começa
  // fechado, como quando se entra pelo botão do topo (25/10/2026).
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const rota = `${window.location.hash || ""}${window.location.pathname || ""}`;
    if (/\/(mesas|comandas|delivery|balcao|totem)(\/|$|\?)/.test(rota)) return false;
    return menuAbertoInicial();
  });
  // Verificar localStorage para restaurar activeTopMenu (útil para navegação de volta)
  const [activeTopMenu, setActiveTopMenu] = useState(() => {
    const saved = localStorage.getItem('activeTopMenu');
    if (saved) {
      localStorage.removeItem('activeTopMenu'); // Limpar após ler
      return saved;
    }
    return null;
  }); // null = nenhuma aba superior ativa
  // Flag para indicar que o usuário clicou manualmente em uma aba (tem prioridade sobre useEffect)
  const [userSelectedTab, setUserSelectedTab] = useState(false);
  // Ref para rastrear quando o usuário clicou no menu lateral (evita que useEffect interfira)
  const sidebarNavigationRef = useRef(false);
  // Ref para indicar que o usuário quer usar o menu lateral (bloqueia ativação automática de abas)
  const usingSidebarMenuRef = useRef(false);
  // Ref para rastrear activeTopMenu atual (evita leitura de valor desatualizado no useEffect)
  const activeTopMenuRef = useRef(activeTopMenu);
  // Estado adicional para garantir que o menu lateral tenha prioridade absoluta
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const [stockControlExpanded, setStockControlExpanded] = useState(false);
  const [cardapioExpanded, setCardapioExpanded] = useState(false);
  const [salesExpanded, setSalesExpanded] = useState(false);
  const [modulesExpanded, setModulesExpanded] = useState(false);
  const [relatoriosExpanded, setRelatoriosExpanded] = useState(false);
  // Chamados de garçom das mesas com QR (som + aviso em qualquer tela).
  const chamadosGarcom = useChamadosGarcom({ ativo: true });
  const [menuSearch, setMenuSearch] = useState("");
  // Busca do menu só aceita digitação depois que o usuário toca nela. Enquanto
  // isso fica `readOnly`, e o Chrome PULA campo readOnly quando despeja o
  // usuário/senha salvos da conta — sem isso, abrir qualquer aba com campo de
  // senha (Integração, trocar senha) jogava o nome da conta aqui e a busca
  // passava a filtrar por ele sozinha.
  const [menuSearchAtiva, setMenuSearchAtiva] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth < 768);
  const [headerHidden, setHeaderHidden] = useState(false);
  // Clique na aba/menu Totem pergunta antes de abrir o modo totem (dono, 25/10/2026)
  const [confirmarTotem, setConfirmarTotem] = useState(false);
  
  // v1.5.362+ MVP Agendamentos: contagem de agendados pendentes pra badge.
  // Poll a cada 60s (barato — 1 COUNT com filter). Também refetch quando aba fica visível.
  const [agendadosCount, setAgendadosCount] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const fetchCount = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch('/api/pedidos/agendados/count', {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok || cancelled) return;
        const data = await res.json();
        if (!cancelled) setAgendadosCount(data);
      } catch { /* silencioso */ }
    };
    fetchCount();
    const id = setInterval(fetchCount, 60_000);
    const onVis = () => { if (document.visibilityState === 'visible') fetchCount(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { cancelled = true; clearInterval(id); document.removeEventListener('visibilitychange', onVis); };
  }, []);

  // Estado de trial
  const [trialInfo, setTrialInfo] = useState(null); // { daysLeft, expired }
  // Alerta da mensalidade no sino: D-5..D-1 (pre), D0 (hoje), D+1..D+28 (vencida).
  // Estado derivado do backend — sempre a verdade do momento, sem dedupe.
  const [billingAviso, setBillingAviso] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/billing/aviso-visual`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (r.ok) {
          const d = await r.json();
          setBillingAviso(d && d.nivel ? d : null);
        }
      } catch (_) {}
    })();
  }, []);

  const fmtAvisoBRL = (v) =>
    (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  // Card do alerta de fatura — usado no sino (desktop) e no menu (mobile)
  const renderBillingAviso = (fechar) => {
    if (!billingAviso || isKDS) return null;
    const { nivel, dias, valor, vencimento } = billingAviso;
    const titulo =
      nivel === "vencida"
        ? `🔴 Mensalidade em atraso — ${dias} dia${dias === 1 ? "" : "s"}`
        : nivel === "hoje"
          ? "⏰ Sua mensalidade vence HOJE"
          : `🧾 Mensalidade vence em ${dias} dia${dias === 1 ? "" : "s"}`;
    const tema =
      nivel === "vencida"
        ? "bg-red-500/10 text-red-600 dark:text-red-400"
        : nivel === "hoje"
          ? "bg-orange-500/10 text-orange-600 dark:text-orange-400"
          : "bg-amber-500/10 text-amber-700 dark:text-amber-400";
    return (
      <div className={`px-4 py-3 text-sm border-b ${tema}`}>
        <p className="font-semibold">{titulo}</p>
        <p className="text-xs mt-0.5 opacity-90">
          {nivel === "vencida" ? "Valor atualizado (multa + juros): " : "Valor: "}
          <strong>{fmtAvisoBRL(valor)}</strong>
          {vencimento ? ` · venc. ${vencimento}` : ""}
        </p>
        {nivel === "vencida" && (
          <p className="text-[11px] mt-1 font-medium">
            Após 28 dias de atraso o sistema é bloqueado automaticamente.
          </p>
        )}
        <button
          onClick={() => {
            fechar();
            handleSidebarClick("/assinatura");
          }}
          className="mt-2 w-full py-1.5 rounded-lg bg-primary text-primary-foreground text-xs font-bold hover:opacity-90 transition-opacity"
        >
          Ver fatura
        </button>
      </div>
    );
  };
  useEffect(() => {
    try {
      const raw = localStorage.getItem('tenant_trial');
      if (raw) {
        const data = JSON.parse(raw);
        if (data.status === 'trial' && data.trial_expires_at) {
          const expires = new Date(data.trial_expires_at);
          const now = new Date();
          const daysLeft = Math.ceil((expires - now) / (1000 * 60 * 60 * 24));
          setTrialInfo({ daysLeft: Math.max(0, daysLeft), expired: daysLeft <= 0, plan: data.plan });
        }
      }
    } catch (_) {}
  }, []);

  // Estado para versão do sistema
  const [versionInfo, setVersionInfo] = useState({
    current: "1.0.0",
    history: []
  });
  const [versionDialogOpen, setVersionDialogOpen] = useState(false);

  // Menu de perfil (dropdown)
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => document.documentElement.classList.contains("dark"));
  const profileMenuRef = useRef(null);

  // Notificações (dropdown do sininho)
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const abasCabecalhoRef = useRef(null);
  const acoesCabecalhoRef = useRef(null);
  const notificationsRef = useRef(null);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setProfileMenuOpen(false);
      }
      if (notificationsRef.current && !notificationsRef.current.contains(e.target)) {
        setNotificationsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Escutar mudanças de tema
  useEffect(() => {
    const handler = (e) => setDarkMode(!!e.detail?.dark);
    window.addEventListener("themeChange", handler);
    return () => window.removeEventListener("themeChange", handler);
  }, []);

  // Tema escolhido pelo próprio usuário (vale em qualquer aparelho dele).
  useEffect(() => { sincronizarTemaDoUsuario(); }, []);

  // "Tema" do menu da foto: muda SÓ para o usuário logado. O padrão da loja
  // é em Configurações → Sistema → Aparência (features/tema).
  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    trocarTemaDoUsuario(newMode ? "dark" : "light");
  };

  // Estado do bot IA (resposta automática) — mirrored from ChatBot page
  const [botConnected, setBotConnected] = useState(false);
  const [botAutoReply, setBotAutoReply] = useState(false);
  const [botToggleLoading, setBotToggleLoading] = useState(false);

  // Estado Aberto/Fechado da loja
  const [storeOpen, setStoreOpen] = useState(true);
  const [storeToggleLoading, setStoreToggleLoading] = useState(false);
  const [storeCloseModalOpen, setStoreCloseModalOpen] = useState(false);
  const [storeOpenModalOpen, setStoreOpenModalOpen] = useState(false);
  const [storeCloseReason, setStoreCloseReason] = useState("");
  const [storeCloseDuration, setStoreCloseDuration] = useState("");
  const [storeReopenAt, setStoreReopenAt] = useState("");
  const [storeCountdown, setStoreCountdown] = useState("");
  const [todayBusinessHours, setTodayBusinessHours] = useState(null);

  // Configurações da empresa
  const [companySettings, setCompanySettings] = useState({
    company_name: "Núcleo",
    slogan: "O Centro da sua Gestão",
    logo_url: null
  });

  // Plano do estabelecimento (starter, professional, enterprise)
  const [userPlan, setUserPlan] = useState("enterprise");

  // Estado do Caixa
  const [caixaAberto, setCaixaAberto] = useState(null);
  // Só depois da 1ª resposta de /caixa/status se sabe se o caixa está aberto
  // (25/10/2026): antes disso o cabeçalho mostrava "Abrir Caixa" com o caixa
  // aberto e o plano Start podia tentar abrir um caixa que já existia.
  const [caixaConhecido, setCaixaConhecido] = useState(false);
  // Avaliacao mensal do lojista (dia 01 ao 05, fora do periodo de teste)
  const [avaliacao, setAvaliacao] = useState(null);
  const [avaliacaoAberta, setAvaliacaoAberta] = useState(false);
  const [abrirCaixaModalOpen, setAbrirCaixaModalOpen] = useState(false);
  const [fecharCaixaModalOpen, setFecharCaixaModalOpen] = useState(false);

  // Polling status do caixa
  useEffect(() => {
    const fetchCaixa = async () => {
      try {
        const tok = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/caixa/status`, {
          headers: tok ? { Authorization: `Bearer ${tok}` } : {}
        });
        // Resposta de erro (401, 500…) não diz nada do caixa: espera a próxima
        if (!res.ok) return;
        const data = await res.json();
        // Caixa aberto sempre tem id; sem id = não há caixa aberto
        setCaixaAberto(data?.status !== "fechado" && data?.id ? data : null);
        setCaixaConhecido(true);
      } catch (_) {}
    };
    fetchCaixa();
    const interval = setInterval(fetchCaixa, 30000);
    return () => clearInterval(interval);
  }, []);

  // Plano Start: caixa nao e gerenciavel — abre automaticamente com R$0 se estiver fechado.
  // Roda apos sabermos userPlan e caixaAberto. Idempotente: so dispara se realmente fechado.
  const startCaixaAutoOpenedRef = useRef(false);
  useEffect(() => {
    if (userPlan !== "start") return;
    if (!caixaConhecido) return; // ainda não sabe se está aberto
    if (caixaAberto !== null) return; // ja aberto
    if (!canAccessModule("caixa_abrir")) return; // sem permissão de abrir: o servidor recusaria
    if (startCaixaAutoOpenedRef.current) return;
    startCaixaAutoOpenedRef.current = true;
    (async () => {
      try {
        await handleAbrirCaixa(0);
      } catch (e) {
        startCaixaAutoOpenedRef.current = false; // permite retry no proximo render se falhar
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPlan, caixaAberto, caixaConhecido]);

  // Carregar status aberto/fechado da loja
  useEffect(() => {
    const fetchStoreStatus = async () => {
      try {
        const tok = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/store/status`, {
          headers: tok ? { Authorization: `Bearer ${tok}` } : {}
        });
        if (res.ok) {
          const data = await res.json();
          setStoreOpen(data.is_open);
          if (data.reopen_at) setStoreReopenAt(data.reopen_at);
        }
      } catch (_) {}
    };
    fetchStoreStatus();
    const interval = setInterval(fetchStoreStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  // Contagem regressiva para reabertura
  useEffect(() => {
    if (storeOpen || !storeReopenAt) {
      setStoreCountdown("");
      return;
    }
    const tick = () => {
      const now = new Date();
      const target = new Date(storeReopenAt);
      const diff = target - now;
      if (diff <= 0) {
        setStoreCountdown("");
        setStoreOpen(true);
        setStoreReopenAt("");
        return;
      }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setStoreCountdown(`${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [storeOpen, storeReopenAt]);

  // Carregar horário de funcionamento do dia atual
  useEffect(() => {
    const fetchHours = async () => {
      try {
        const tok = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/business-hours`, {
          headers: tok ? { Authorization: `Bearer ${tok}` } : {}
        });
        if (res.ok) {
          const hours = await res.json();
          // day_of_week do Núcleo: 0 = Segunda … 6 = Domingo (getDay(): 0 = Domingo).
          const hoje = (new Date().getDay() + 6) % 7;
          const todayHour = hours.find(h => h.day_of_week === hoje);
          setTodayBusinessHours(todayHour);
        }
      } catch (_) {}
    };
    fetchHours();
  }, []);

  const handleStoreClick = () => {
    if (storeOpen) {
      setStoreCloseReason("");
      setStoreCloseDuration("");
      setStoreCloseModalOpen(true);
    } else {
      setStoreOpenModalOpen(true);
    }
  };

  const handleStoreClose = async () => {
    if (!storeCloseReason || !storeCloseDuration) return;
    setStoreToggleLoading(true);
    try {
      const tok = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/store/close`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...(tok ? { Authorization: `Bearer ${tok}` } : {}) },
        body: JSON.stringify({ reason: storeCloseReason, duration: storeCloseDuration })
      });
      if (res.ok) {
        const data = await res.json();
        setStoreOpen(false);
        if (data.reopen_at) setStoreReopenAt(data.reopen_at);
        setStoreCloseModalOpen(false);
        const durationLabels = { "5": "5 minutos", "10": "10 minutos", "15": "15 minutos", "30": "30 minutos", "60": "1 hora", "120": "2 horas", "today": "o dia de hoje", "permanent": "tempo indeterminado" };
        toast.success(`Loja fechada por ${durationLabels[storeCloseDuration] || storeCloseDuration}`);
      }
    } catch (_) {
      toast.error("Erro ao fechar a loja");
    }
    setStoreToggleLoading(false);
  };

  const handleStoreOpen = async () => {
    setStoreToggleLoading(true);
    try {
      const tok = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/store/open`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...(tok ? { Authorization: `Bearer ${tok}` } : {}) }
      });
      if (res.ok) {
        setStoreOpen(true);
        setStoreReopenAt("");
        setStoreOpenModalOpen(false);
        toast.success("Loja aberta!");
      }
    } catch (_) {
      toast.error("Erro ao abrir a loja");
    }
    setStoreToggleLoading(false);
  };

  const handleAbrirCaixa = async (valor) => {
    const tok = localStorage.getItem("token");
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/caixa/abrir`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(tok ? { Authorization: `Bearer ${tok}` } : {}) },
      body: JSON.stringify({ valor_abertura: valor })
    });
    if (!res.ok) { const e = await res.json(); throw new Error(e.detail); }
    const c = await res.json();
    setCaixaAberto(c);
    toast.success("Caixa aberto com sucesso!");
  };

  // Configuração das abas superiores com ícones e rotas explícitas (URLs diretas, sem /admin)
  // `moduleKey` é usado para esconder a aba quando o usuário (funcionário) não tem permissão.
  const topMenuItems = [
    { id: 'cardapio', label: 'Cardápio', icon: Store, path: '/cardapio-admin', hidden: true, moduleKey: 'cardapio' },
    { id: 'mesas', label: 'Mesas', icon: MesaIcon, path: '/mesas', requiredPlan: 'start', moduleKey: 'mesas' },
    // Comandas (24/10/2026): conta em nome do cliente, sem mesa. Nasce desligado em Preferências.
    { id: 'comandas', label: 'Comandas', icon: ClipboardList, path: '/comandas', moduleKey: 'comandas' },
    { id: 'balcao', label: 'Balcão', icon: CaixaRegistradoraIcon, path: '/balcao', requiredPlan: 'completo', hideOnMobile: true, moduleKey: 'balcao' },
    // Totem (25/10/2026): saiu de dentro do Balcão e virou aba própria; abre o
    // autoatendimento em tela cheia. Some quando o Totem é desligado em Preferências.
    { id: 'totem', label: 'Totem', icon: TotemIcon, path: '/totem', requiredPlan: 'completo', hideOnMobile: true, moduleKey: 'totem' },
    { id: 'delivery', label: 'Delivery', icon: MotoEntregaIcon, path: '/delivery', moduleKey: 'delivery' },
  ];

  // Buscar configurações da empresa
  useEffect(() => {
    const fetchCompanySettings = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/company/settings`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        if (res.ok) {
          const data = await res.json();
          setCompanySettings(data);
          if (data.plan) setUserPlan(data.plan);
          // Atualizar título do documento
          document.title = data.company_name || "Núcleo";
        }
      } catch (error) {
        console.error("Erro ao buscar configurações da empresa:", error);
      }
    };
    fetchCompanySettings();
  }, []);

  // Carregar versão do sistema
  useEffect(() => {
    const loadVersion = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        if (res.ok) {
          const data = await res.json();
          setVersionInfo(data);
        }
      } catch (error) {
        console.error("Erro ao carregar versão:", error);
      }
    };
    loadVersion();
  }, []);

  // Polling do status do bot IA + sincronização em tempo real via BroadcastChannel.
  // - Dashboard e ChatBot publicam alterações no canal "nucleo-bot-status"
  // - Cada aba/tela escuta e atualiza o estado local instantaneamente
  // - Polling continua (60s) só pra absorver mudanças externas (ex: webhook, processo do
  //   serviço caindo). O usuário enxerga refletido imediatamente quando alterna em qualquer lado.
  useEffect(() => {
    let cancelled = false;
    let channel = null;
    try {
      if (typeof window !== "undefined" && "BroadcastChannel" in window) {
        channel = new BroadcastChannel("nucleo-bot-status");
        channel.onmessage = (ev) => {
          const data = ev?.data || {};
          if (typeof data.connected === "boolean") setBotConnected(data.connected);
          if (typeof data.autoReplyEnabled === "boolean") setBotAutoReply(data.autoReplyEnabled);
        };
      }
    } catch (_) { channel = null; }

    const onWindowEvent = (ev) => {
      const data = ev?.detail || {};
      if (typeof data.connected === "boolean") setBotConnected(data.connected);
      if (typeof data.autoReplyEnabled === "boolean") setBotAutoReply(data.autoReplyEnabled);
    };
    window.addEventListener("nucleo-bot-status", onWindowEvent);

    const fetchBotStatus = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch("/api/whatsapp/status", {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        // Loja só no WhatsApp oficial: vale a conexão oficial (não há QR Code).
        setBotConnected(!!(data.somente_oficial ? data.oficial_conectado : data.connected));
        setBotAutoReply(!!data.autoReplyEnabled);
      } catch (_) { /* silencioso */ }
    };
    fetchBotStatus();
    const interval = setInterval(fetchBotStatus, 60000);

    return () => {
      cancelled = true;
      clearInterval(interval);
      window.removeEventListener("nucleo-bot-status", onWindowEvent);
      try { channel && channel.close(); } catch (_) {}
    };
  }, []);

  const broadcastBotStatus = (payload) => {
    try {
      if (typeof window !== "undefined" && "BroadcastChannel" in window) {
        const ch = new BroadcastChannel("nucleo-bot-status");
        ch.postMessage(payload);
        ch.close();
      }
    } catch (_) {}
    try {
      window.dispatchEvent(new CustomEvent("nucleo-bot-status", { detail: payload }));
    } catch (_) {}
  };

  const handleToggleBot = async () => {
    if (botToggleLoading) return;
    if (!botConnected) {
      toast.info("Conecte o WhatsApp em ChatBot antes de ativar a IA");
      return;
    }
    setBotToggleLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/whatsapp/toggle-auto-reply", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      const data = await res.json();
      if (data.success) {
        const enabled = !!data.autoReplyEnabled;
        setBotAutoReply(enabled);
        broadcastBotStatus({ autoReplyEnabled: enabled, connected: botConnected });
        toast.success(enabled ? "IA ativada" : "IA desativada");
      } else {
        toast.error("Não foi possível alterar o estado da IA");
      }
    } catch (_) {
      toast.error("Erro ao alterar o estado da IA");
    } finally {
      setBotToggleLoading(false);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      try { setCurrentUser(JSON.parse(user)); } catch (_) {}
    }
    // O usuário guardado no login fica velho quando o dono muda as permissões
    // (v1.5.789: permissões do caixa). /auth/me traz as de agora.
    const tok = localStorage.getItem("token");
    if (!tok) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/auth/me`, { headers: { Authorization: `Bearer ${tok}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((me) => {
        if (!me || !me.id) return;
        setCurrentUser(me);
        try { localStorage.setItem("user", JSON.stringify(me)); } catch (_) { /* só cache */ }
      })
      .catch(() => {});
  }, []);

  // Helper: usuário pode ver este módulo do menu?
  // - proprietario/administrador vêem tudo
  // - outros (funcionario): só vê os módulos listados em allowed_modules
  // - sem currentUser carregado ainda: libera (evita flash de menu vazio)
  // Módulo desligado em Preferências → "Módulos da loja" some para todo mundo,
  // inclusive o dono (29/09/2026).
  const { ligado: moduloLigado } = useModulosLoja();
  const canAccessModule = useCallback((moduleKey) => {
    if (["mesas", "comandas", "balcao", "totem", "delivery"].includes(moduleKey) && !moduloLigado(moduleKey)) return false;
    if (!currentUser) return true;
    const role = (currentUser.role || "").toLowerCase();
    if (role === "proprietario" || role === "administrador") return true;
    const allowed = Array.isArray(currentUser.allowed_modules) ? currentUser.allowed_modules : [];
    // Totem não tem permissão própria: quem opera o Balcão abre o Totem
    return allowed.includes(moduleKey === "totem" ? "balcao" : moduleKey);
  }, [currentUser, moduloLigado]);

  // Visão Geral, Indique e Ganhe e ChatBot eram exclusivos de proprietário e
  // administrador. Desde 07/10/2026 cada um é uma permissão do cadastro do
  // funcionário (visao_geral, indique_ganhe, chatbot), como os outros módulos.
  const podeVisaoGeral = canAccessModule("visao_geral");
  const podeChatbot = canAccessModule("chatbot");

  // Primeira rota acessível ao funcionário, usada como "home" quando ele não
  // pode ver Visão Geral.
  const firstAllowedRoute = useMemo(() => {
    if (podeVisaoGeral) return "/";
    const allowed = Array.isArray(currentUser?.allowed_modules) ? currentUser.allowed_modules : [];
    const FIRST_ROUTE_BY_MODULE = {
      entregas: "/vendas/entregas",
      pedidos: "/vendas/pedidos",
      kds: "/kds",
      mesas: "/mesas",
      comandas: "/comandas",
      balcao: "/balcao",
      delivery: "/delivery",
      cardapio: "/produtos",
      estoque: "/estoque",
      relatorios: "/vendas/relatorio",
      pessoas: "/clientes-fornecedores/clientes",
      localizacao: "/localizacao/bairros",
      financeiro: "/financeiro/caixa",
      impulsione: "/impulsione/promocoes",
      chatbot: "/chatbot",
      configuracoes: "/configuracoes/sistema",
      indique_ganhe: "/indique-e-ganhe",
    };
    // v1.5.407 — a "home" precisa ser uma rota USÁVEL, não só permitida:
    //  (a) o KDS esconde sidebar E header (isKDS), então quem cai lá fica sem
    //      menu e sem botão Sair — só serve como home se não houver alternativa;
    //  (b) rota bloqueada pelo PLANO da loja renderiza embaçada e sem cliques
    //      (PlanGateOverlay usa pointer-events-none) — combinada com (a) vira
    //      beco sem saída total: o preset "Cozinheiro" (kds+pedidos) numa loja
    //      do plano Start jogaria o funcionário numa tela sem NENHUM controle
    //      clicável (no app Electron, sem barra de URL, sem escapatória).
    // Por isso: 1º as rotas usáveis e liberadas no plano; depois as liberadas
    // mesmo que escondam o chrome; e só então qualquer permitida.
    const SEM_CHROME = new Set(["kds"]);
    const rotaDe = (mod) => FIRST_ROUTE_BY_MODULE[mod];
    const noPlano = (rota) => {
      try {
        return hasAccess(userPlan, getRequiredPlan(rota));
      } catch (_) {
        return true; // falha do helper nunca pode travar a escolha de home
      }
    };
    const candidatas = allowed.map(rotaDe).filter(Boolean);
    const preferidas = allowed.filter(m => !SEM_CHROME.has(m)).map(rotaDe).filter(Boolean);

    return preferidas.find(noPlano)      // ideal: navegável + liberada
      || candidatas.find(noPlano)        // liberada, ainda que sem menu (KDS)
      || preferidas[0]                   // permitida, ainda que travada por plano
      || candidatas[0]
      || "/vendas/pedidos";              // fallback razoável
  }, [podeVisaoGeral, currentUser, userPlan]);

  // Redireciona o funcionário pra primeira rota permitida dele.
  //
  // v1.5.406 — o prefixo `/admin` é OBRIGATÓRIO. O Dashboard só é montado em
  // `<Route path="/admin/*">` (App.js); um `navigate("/vendas/entregas")` sem
  // prefixo cai no catch-all `path="/*"` do App, que faz `<Navigate to="/admin/">`
  // — e "/admin/" é justamente a Visão Geral, rota proibida pro funcionário.
  // Resultado: guard redireciona → App devolve pra Visão Geral → guard redireciona…
  // LOOP INFINITO, com o Dashboard remontando várias vezes por segundo e a Visão
  // Geral disparando ~10 requests pesados a cada volta (caso real: entregador da
  // UAI PIZZA, "Erro ao carregar horários" + enxurrada de NS_BINDING_ABORTED).
  // Todo o resto do arquivo já navega com `/admin${path}` — este guard era a
  // única exceção.
  const goHomePermitida = useCallback(() => {
    const destino = `/admin${firstAllowedRoute}`;
    // Trava anti-loop: se JÁ estamos no destino e o guard ainda quer redirecionar,
    // é porque a própria home permitida caiu numa regra de bloqueio (ex.: usuário
    // com allowed_modules vazio, cujo fallback é /vendas/pedidos, rota que o guard
    // proíbe). Navegar de novo pro mesmo lugar só giraria — melhor parar e logar.
    // Comparação com a rota ATUAL (não um contador), pra não travar o funcionário
    // que navega várias vezes pra rotas proibidas na mesma sessão.
    if (location.pathname === destino) {
      console.error("[GUARD] Home permitida também é bloqueada — parando:", destino);
      return;
    }
    navigate(destino, { replace: true });
  }, [navigate, firstAllowedRoute, location.pathname]);

  // Bloquear acesso a rotas que o usuário não pode ver: redireciona pra home.
  // Mapeia path -> moduleKey conforme a estrutura do menu.
  useEffect(() => {
    if (!currentUser) return;
    const role = (currentUser.role || "").toLowerCase();
    if (role === "proprietario" || role === "administrador") return;
    const allowed = new Set(Array.isArray(currentUser.allowed_modules) ? currentUser.allowed_modules : []);
    const path = location.pathname.replace("/admin", "") || "/";

    const ROUTE_TO_MODULE = [
      [/^\/$/, "visao_geral"],
      [/^\/indique-e-ganhe/, "indique_ganhe"],
      [/^\/chatbot/, "chatbot"],
      [/^\/produtos/, "cardapio"],
      [/^\/estoque\/relatorio/, "relatorios"],
      [/^\/estoque/, "estoque"],
      [/^\/compras/, "estoque"],
      [/^\/vendas\/relatorio/, "relatorios"],
      [/^\/vendas\/pedidos/, "pedidos"],
      [/^\/vendas\/entregas/, "entregas"],
      [/^\/kds/, "kds"],
      [/^\/mesas/, "mesas"],
      [/^\/comandas/, "comandas"],
      [/^\/balcao/, "balcao"],
      [/^\/totem/, "balcao"],
      [/^\/delivery/, "delivery"],
      [/^\/relatorios/, "relatorios"],
      [/^\/clientes-fornecedores/, "pessoas"],
      [/^\/localizacao/, "localizacao"],
      [/^\/financeiro/, "financeiro"],
      [/^\/impulsione\/relatorio-ofertas/, "relatorios"],
      [/^\/impulsione/, "impulsione"],
      [/^\/configuracoes/, "configuracoes"],
      [/^\/assinatura/, "configuracoes"],
      [/^\/cardapio-admin/, "cardapio"],
    ];
    for (const [re, key] of ROUTE_TO_MODULE) {
      if (re.test(path)) {
        if (!allowed.has(key)) {
          goHomePermitida();
        }
        return;
      }
    }
  }, [location.pathname, currentUser, navigate, firstAllowedRoute, goHomePermitida]);

  // Rota de módulo desligado em Preferências (Mesas, Balcão, Delivery) volta
  // para o início — vale para todos, inclusive o dono.
  useEffect(() => {
    const path = location.pathname.replace("/admin", "") || "/";
    const alvo = [[/^\/mesas/, "mesas"], [/^\/comandas/, "comandas"], [/^\/balcao/, "balcao"], [/^\/totem/, "totem"], [/^\/delivery/, "delivery"]].find(([re]) => re.test(path));
    if (alvo && !moduloLigado(alvo[1])) goHomePermitida();
  }, [location.pathname, moduloLigado, goHomePermitida]);

  // Atualizar ref quando activeTopMenu mudar
  useEffect(() => {
    activeTopMenuRef.current = activeTopMenu;
  }, [activeTopMenu]);

  // isMobile: escuta resize para esconder menu superior na aba Mesas em mobile
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);


  // Sincronizar activeTopMenu com a URL atual
  useEffect(() => {
    // Obter path atual (pode ser /admin/path ou /path)
    let currentPath = location.pathname;
    
    // Se começar com /admin, remover
    if (currentPath.startsWith('/admin')) {
      currentPath = currentPath.replace('/admin', '') || '/';
    }
    
    logger.debug('🔵 useEffect - currentPath:', currentPath, 'location.pathname:', location.pathname);
    
    // Buscar item do menu superior correspondente
    const topMenuItem = topMenuItems.find(item => {
      const itemPath = item.path.startsWith('/') ? item.path : `/${item.path}`;
      const matches = currentPath === itemPath || currentPath.startsWith(itemPath + '/');
      if (matches) {
        logger.debug('🔵 Rota do menu superior encontrada:', item.id, 'path:', itemPath);
      }
      return matches;
    });
    
    if (topMenuItem) {
      // Se estamos em uma rota do menu superior, ativar a aba correspondente
      if (activeTopMenuRef.current !== topMenuItem.id) {
        logger.debug('🔵 Sincronizando activeTopMenu com URL:', topMenuItem.id, 'path:', currentPath);
        setActiveTopMenu(topMenuItem.id);
        activeTopMenuRef.current = topMenuItem.id;
        usingSidebarMenuRef.current = false;
        sidebarNavigationRef.current = false;
        setIsSidebarActive(false);
      }
    } else if (activeTopMenuRef.current !== null) {
      // Verificar se não estamos em nenhuma rota do menu superior
      const isTopMenuRoute = topMenuItems.some(item => {
        const itemPath = item.path.startsWith('/') ? item.path : `/${item.path}`;
        return currentPath === itemPath || currentPath.startsWith(itemPath + '/');
      });
      if (!isTopMenuRoute) {
        logger.debug('🔵 Limpando activeTopMenu - não é rota do menu superior');
        setActiveTopMenu(null);
        activeTopMenuRef.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.hash]);


  // REMOVIDO COMPLETAMENTE: useEffect que estava TRAVANDO a navegação
  // A navegação agora é 100% controlada pelos cliques do usuário - SEM INTERFERÊNCIA

  const handleLogout = () => {
    removeToken();
    // Limpar todas as chaves relacionadas ao tenant atual
    ['user', 'client', 'fornecedores', 'mesas', 'tenant_trial'].forEach(k => {
      try { localStorage.removeItem(k); } catch {}
    });
    setIsAuthenticated(false);
    toast.success("Logout realizado!");
    if (window.nucleoDesktop) {
      window.nucleoDesktop.changeRestaurant();
    }
  };

  const handleNavigate = (path) => {
    setActiveTopMenu(null); // Desativa aba superior ao navegar pelo menu lateral
    setUserSelectedTab(false); // Resetar flag ao navegar pelo menu lateral
    navigate(`/admin${path}`);
    if (window.innerWidth < 1024) {
      setSidebarOpen(false);
    }
  };

  // Click bloqueado em items que o plano nao permite — exibe toast no lugar de navegar.
  const handleLockedClick = (requiredPlan) => {
    const label = getPlanLabel(requiredPlan);
    toast.info(`Disponível no plano ${label}`, {
      action: { label: "Ver planos", onClick: () => window.open("https://usenucleo.com.br/#planos", "_blank", "noopener,noreferrer") },
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/avaliacao/status`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setAvaliacao(d))
      .catch(() => {});
  }, []);

  const handleSidebarClick = (path) => {
    if (path === "/totem") { setConfirmarTotem(true); return; }
    // CORREÇÃO: Resetar activeTopMenu IMEDIATAMENTE e navegar SEM chamar /leave
    // O /leave será chamado automaticamente pelo componente Delivery quando desmontar
    console.log('🧭 Navegação lateral:', path);
    
    // CRÍTICO: Marcar que estamos usando o menu lateral (bloqueia qualquer ativação automática de delivery)
    usingSidebarMenuRef.current = true;
    sidebarNavigationRef.current = true;
    setIsSidebarActive(true);
    
    // 1. Muda estado IMEDIATAMENTE (síncrono)
    setActiveTopMenu(null);
    activeTopMenuRef.current = null;

    // Fechar sidebar ao navegar de tela cheia ou mobile
    // Desktop: volta pro que o usuário escolheu no ☰. Antes reabria o menu à
    // força toda vez que se clicava numa aba com o menu recolhido.
    if (isFullscreenTab || window.innerWidth < 1024) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(menuAbertoPreferido());
    }
    
    // 2. Navega IMEDIATAMENTE - sem esperar nada
    navigate(`/admin${path}`);
    
    // CRÍTICO: NÃO chamar /leave aqui - isso causava o erro 422
    // O componente Delivery já tem handleBeforeUnload que cuida disso
    // E se falhar, não deve interferir na navegação
    
    // CORREÇÃO: NÃO resetar as flags imediatamente
    // Manter as flags ativas por mais tempo para garantir que Delivery não seja renderizado
    // As flags serão resetadas quando o usuário clicar em uma aba do menu superior
  };

  // Accordion: abre apenas um modulo por vez; clicar no ja aberto fecha.
  const handleModuleClick = (setter, currentlyExpanded) => {
    if (!sidebarOpen) {
      setSidebarOpen(true);
    }
    collapseAllMenus();
    setter(!currentlyExpanded);
  };

  const [configExpanded, setConfigExpanded] = useState(false);
  const [clientesFornecedoresExpanded, setClientesFornecedoresExpanded] = useState(false);
  const [financeiroExpanded, setFinanceiroExpanded] = useState(false);
  const [impulsioneVendasExpanded, setImpulsioneVendasExpanded] = useState(false);
  const [localizacaoExpanded, setLocalizacaoExpanded] = useState(false);

  // Função para recolher todas as abas do menu
  const collapseAllMenus = () => {
    setCardapioExpanded(false);
    setStockControlExpanded(false);
    setSalesExpanded(false);
    setRelatoriosExpanded(false);
    setClientesFornecedoresExpanded(false);
    setFinanceiroExpanded(false);
    setImpulsioneVendasExpanded(false);
    setConfigExpanded(false);
    setLocalizacaoExpanded(false);
  };

  // Listener para recolher menus quando navegar via StockNavBar
  useEffect(() => {
    const handler = () => collapseAllMenus();
    window.addEventListener("collapse-sidebar-menus", handler);
    return () => window.removeEventListener("collapse-sidebar-menus", handler);
  }, []);

  // Função para alternar o sidebar e recolher menus quando minimizar
  const toggleSidebar = () => {
    if (sidebarOpen) {
      // Ao minimizar, recolher todas as abas
      collapseAllMenus();
    }
    salvarMenuAberto(!sidebarOpen);
    setSidebarOpen(!sidebarOpen);
  };

  // Estrutura de navegação principal
  const mainTabs = [
    { path: "/", label: "Visão Geral", icon: Home, type: "single", moduleKey: "visao_geral" },
    // Programa LANÇADO em 25/08/2026 (v1.5.448). Saiu o `comingSoon: true`, que
    // bloqueava o clique, e o badge "Em breve" — sem `badgeLabel`/`badgeVariant`
    // o NewBadge cai no default "Novo" verde. `newUntil` = 30 dias, mesma janela
    // usada nas outras abas novas.
    { path: "/indique-e-ganhe", label: "Indique e Ganhe", icon: Gift, type: "single", newUntil: "2026-09-24", moduleKey: "indique_ganhe" },
  ];

  // Helper: filtra children pela permissão do usuário (allowed_modules)
  const filterByModule = (children) => children.filter(c => canAccessModule(c.moduleKey));

  // Cardapio (novo modulo - fica logo abaixo de Indique e Ganhe)
  const cardapioModule = {
    label: "Cardápio",
    icon: UtensilsCrossed,
    expanded: cardapioExpanded,
    toggle: () => setCardapioExpanded(!cardapioExpanded),
    children: filterByModule([
      { path: "/produtos", label: "Produtos", icon: FileText, moduleKey: "cardapio" },
      { path: "/cardapio/banners", label: "Banners", icon: Images, moduleKey: "cardapio", newUntil: "2026-09-25" },
    ])
  };

  // Estrutura hierárquica de Estoque
  const stockControlModule = {
    label: "Estoque",
    icon: BarChart3,
    expanded: stockControlExpanded,
    toggle: () => setStockControlExpanded(!stockControlExpanded),
    children: filterByModule([
      { path: "/estoque", label: "Estoque", icon: Package, requiredPlan: "completo", moduleKey: "estoque" },
      { path: "/compras", label: "Compras", icon: ShoppingCart, requiredPlan: "completo", moduleKey: "estoque" },
    ])
  };

  // Estrutura hierárquica de Vendas
  const salesModule = {
    label: "Vendas",
    icon: DollarSign,
    expanded: salesExpanded,
    toggle: () => setSalesExpanded(!salesExpanded),
    children: filterByModule([
      { path: "/vendas/pedidos", label: "Pedidos", icon: ClipboardList, moduleKey: "pedidos" },
      { path: "/vendas/entregas", label: "Entregas", icon: Truck, requiredPlan: "start", moduleKey: "entregas" },
    ])
  };

  // Módulos de operação (Mesas / Balcão / Delivery) — alternativa ao top menu
  const modulesModule = {
    label: "Módulos",
    icon: LayoutGrid,
    expanded: modulesExpanded,
    toggle: () => setModulesExpanded(!modulesExpanded),
    children: filterByModule([
      { path: "/mesas", label: "Mesas", icon: MesaIcon, requiredPlan: "start", moduleKey: "mesas" },
      { path: "/comandas", label: "Comandas", icon: ClipboardList, moduleKey: "comandas" },
      { path: "/balcao", label: "Balcão", icon: CaixaRegistradoraIcon, requiredPlan: "completo", moduleKey: "balcao" },
      { path: "/totem", label: "Totem", icon: TotemIcon, requiredPlan: "completo", moduleKey: "totem" },
      { path: "/delivery", label: "Delivery", icon: MotoEntregaIcon, moduleKey: "delivery" },
    ])
  };

  // Modulo Relatorios (agrega todos os relatorios do sistema)
  const relatoriosModule = {
    label: "Relatórios",
    icon: PieChart,
    expanded: relatoriosExpanded,
    toggle: () => setRelatoriosExpanded(!relatoriosExpanded),
    children: filterByModule([
      { path: "/relatorios/cardapio", label: "Relatório Cardápio", icon: UtensilsCrossed, requiredPlan: "start", moduleKey: "relatorios", newUntil: "2026-07-07", badgeLabel: "Atualizado", badgeVariant: "updated" },
      { path: "/relatorios/categorias", label: "Relatório de Categorias", icon: Layers, requiredPlan: "start", moduleKey: "relatorios", newUntil: "2026-07-05" },
      { path: "/estoque/relatorio", label: "Relatório de Estoque", icon: Package, requiredPlan: "completo", moduleKey: "relatorios" },
      { path: "/vendas/relatorio", label: "Relatório de Vendas", icon: DollarSign, requiredPlan: "start", moduleKey: "relatorios" },
      { path: "/vendas/relatorio-produtos", label: "Relatório de Produtos", icon: ShoppingBag, requiredPlan: "start", moduleKey: "relatorios" },
      { path: "/vendas/relatorio-modulos", label: "Relatório de Módulos", icon: Layers, requiredPlan: "start", moduleKey: "relatorios" },
      { path: "/vendas/relatorio-pagamentos", label: "Relatório de Pagamentos", icon: CreditCard, requiredPlan: "start", moduleKey: "relatorios" },
      // Relatório de Tempo (27/10/2026): permanência de mesa/comanda e etapas do delivery, módulo a módulo.
      { path: "/relatorios/tempo", label: "Relatório de Tempo", icon: Timer, requiredPlan: "start", moduleKey: "relatorios", newUntil: "2026-11-27", badgeLabel: "Novo", badgeVariant: "new" },
      { path: "/impulsione/relatorio-ofertas", label: "Relatório de Ofertas", icon: Megaphone, requiredPlan: "completo", moduleKey: "relatorios", newUntil: "2026-07-23", badgeLabel: "Novo", badgeVariant: "new" },
      // Anúncios Meta (04/10/2026): gasto da Meta × pedidos do Núcleo por campanha (docs/features/meta-ads, fase 3).
      { path: "/relatorios/anuncios-meta", label: "Relatório de Anúncios Meta", icon: Megaphone, requiredPlan: "start", moduleKey: "relatorios", newUntil: "2026-10-25" },
      { path: "/relatorios/avaliacoes", label: "Relatório de Avaliações", icon: Sparkles, moduleKey: "relatorios", newUntil: "2026-07-15", badgeLabel: "Atualizado", badgeVariant: "updated" },
    ])
  };

  // Estrutura hierárquica de Pessoas e Fornecedores
  const clientesFornecedoresModule = {
    label: "Pessoas e Fornecedores",
    icon: Users,
    expanded: clientesFornecedoresExpanded,
    toggle: () => setClientesFornecedoresExpanded(!clientesFornecedoresExpanded),
    children: filterByModule([
      { path: "/clientes-fornecedores/clientes", label: "Clientes", icon: UserRound, moduleKey: "pessoas" },
      { path: "/clientes-fornecedores/fornecedores", label: "Fornecedores", icon: Building2, requiredPlan: "completo", moduleKey: "pessoas" },
      { path: "/clientes-fornecedores/funcionarios", label: "Funcionários", icon: Briefcase, moduleKey: "pessoas" },
    ])
  };

  // Estrutura hierárquica de Localização
  const localizacaoModule = {
    label: "Localização",
    icon: MapPin,
    expanded: localizacaoExpanded,
    toggle: () => setLocalizacaoExpanded(!localizacaoExpanded),
    children: filterByModule([
      { path: "/localizacao/bairros", label: "Bairros", icon: MapPin, moduleKey: "localizacao" },
      // "Área de Entrega" saiu do menu (pedido do dono, 23/10/2026: nunca usada). A tela
      // e a rota /localizacao/area-entrega continuam guardadas para quando voltar.
    ])
  };

  // Estrutura hierárquica de Configurações
  const configModule = {
    label: "Configurações",
    icon: Settings,
    expanded: configExpanded,
    toggle: () => setConfigExpanded(!configExpanded),
    children: filterByModule([
      { path: "/configuracoes/horarios", label: "Horários", icon: ClipboardList, moduleKey: "configuracoes" },
      { path: "/configuracoes/sistema", label: "Sistema", icon: Settings, moduleKey: "configuracoes" },
    ])
  };

  // Estrutura hierárquica de Financeiro
  const financeiroModule = {
    label: "Financeiro",
    icon: Wallet,
    expanded: financeiroExpanded,
    toggle: () => setFinanceiroExpanded(!financeiroExpanded),
    children: filterByModule([
      { path: "/financeiro/caixa", label: "Caixa", icon: DollarSign, requiredPlan: "start", moduleKey: "financeiro" },
      // DRE lancado em 25/08/2026. Sai o `comingSoon` (que bloqueava o clique) e
      // o badge "Em breve"; sem badgeLabel o NewBadge cai no default "Novo".
      { path: "/financeiro/extrato", label: "DRE", icon: Receipt, requiredPlan: "completo", moduleKey: "financeiro", newUntil: "2026-10-02" },
      { path: "/financeiro/fluxo-caixa", label: "Fluxo de Caixa", icon: Landmark, moduleKey: "financeiro", newUntil: "2026-10-08" },
      { path: "/financeiro/despesas", label: "Despesas", icon: CreditCard, requiredPlan: "completo", moduleKey: "financeiro" },
      { path: "/financeiro/formas-pagamento", label: "Formas de Pagamento", icon: CreditCard, moduleKey: "financeiro" },
      // Módulo Fiscal liberado em 02/09/2026 (v1.5.546): a página deixou de ser
      // card "em breve" e virou a edição em massa do cadastro fiscal do cardápio.
      // Sai o `comingSoon` (que bloqueava o clique) e o badge "Em breve"; sem
      // badgeLabel o NewBadge cai no default "Novo". A emissão em si ainda não
      // existe — o que está no ar é o cadastro que ela vai consumir.
      { path: "/financeiro/fiscal", label: "Módulo Fiscal", icon: FileText, requiredPlan: "completo", moduleKey: "financeiro", newUntil: "2026-10-02" },
    ])
  };

  // Estrutura hierárquica de Impulsione suas Vendas
  const impulsioneVendasModule = {
    label: "Impulsione suas Vendas",
    icon: Megaphone,
    expanded: impulsioneVendasExpanded,
    toggle: () => setImpulsioneVendasExpanded(!impulsioneVendasExpanded),
    children: filterByModule([
      // Promoções e Cupons viraram dois itens (pedido do dono, 23/10/2026; antes "Promo e Cupons" com abas).
      { path: "/impulsione/promocoes", label: "Promoções", icon: Gift, requiredPlan: "start", moduleKey: "impulsione" },
      { path: "/impulsione/cupons", label: "Cupons", icon: Ticket, requiredPlan: "start", moduleKey: "impulsione" },
      // Campanhas é de todas as lojas desde 17/09/2026 (fim dos planos).
      { path: "/impulsione/campanhas", label: "Campanhas", icon: Megaphone, requiredPlan: "start", moduleKey: "impulsione" },
      // v1.5.466 (pedido do dono): CLUBE deletado (era "Em breve" desde a
      // v1.5.348, clique bloqueado — a ideia renasce dentro de Fidelize);
      // AGENDAMENTOS mudou pra Configurações → Horários (agendar pedido é
      // regra de QUANDO a loja atende — a rota antiga segue funcionando).
      { path: "/impulsione/fidelize", label: "Fidelize seu cliente", icon: Crown, requiredPlan: "start", moduleKey: "impulsione", newUntil: "2026-09-25" },
      { path: "/impulsione/disparos", label: "Disparos em massa", icon: Send, requiredPlan: "start", moduleKey: "impulsione", newUntil: "2026-09-25" },
      { path: "/impulsione/links", label: "Links de divulgação", icon: Share2, requiredPlan: "start", moduleKey: "impulsione", newUntil: "2026-10-05" },
      // Anúncios Meta (04/10/2026): conexão da conta de anúncios da loja e gasto por campanha (docs/features/meta-ads).
      { path: "/impulsione/anuncios-meta", label: "Anúncios Meta", icon: Megaphone, requiredPlan: "start", moduleKey: "impulsione", newUntil: "2026-10-25" },
    ])
  };

  // Estado de bloqueio de cada modulo (header) — quando todos os filhos sao bloqueados,
  // o header recebe line-through + chip do plano e desce pro fim da lista (CSS order=2).
  const moduleLocks = {
    cardapio: getModuleLockState(cardapioModule.children, userPlan),
    stock: getModuleLockState(stockControlModule.children, userPlan),
    impulsione: getModuleLockState(impulsioneVendasModule.children, userPlan),
    sales: getModuleLockState(salesModule.children, userPlan),
    modules: getModuleLockState(modulesModule.children, userPlan),
    relatorios: getModuleLockState(relatoriosModule.children, userPlan),
    pessoas: getModuleLockState(clientesFornecedoresModule.children, userPlan),
    financeiro: getModuleLockState(financeiroModule.children, userPlan),
    localizacao: getModuleLockState(localizacaoModule.children, userPlan),
    config: getModuleLockState(configModule.children, userPlan),
  };

  // Itens pesquisaveis do menu lateral (plano com parent para exibir breadcrumb)
  const normalizeSearch = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const searchableItems = [
    ...mainTabs.filter((t) => canAccessModule(t.moduleKey)).map((t) => ({ ...t, parent: null })),
    ...cardapioModule.children.map((c) => ({ ...c, parent: cardapioModule.label })),
    ...stockControlModule.children.map((c) => ({ ...c, parent: stockControlModule.label })),
    ...impulsioneVendasModule.children.map((c) => ({ ...c, parent: impulsioneVendasModule.label })),
    ...salesModule.children.map((c) => ({ ...c, parent: salesModule.label })),
    ...modulesModule.children.map((c) => ({ ...c, parent: modulesModule.label })),
    ...relatoriosModule.children.map((c) => ({ ...c, parent: relatoriosModule.label })),
    ...clientesFornecedoresModule.children.map((c) => ({ ...c, parent: clientesFornecedoresModule.label })),
    ...financeiroModule.children.map((c) => ({ ...c, parent: financeiroModule.label })),
    ...localizacaoModule.children.map((c) => ({ ...c, parent: localizacaoModule.label })),
    ...configModule.children.map((c) => ({ ...c, parent: configModule.label })),
    ...(podeChatbot ? [{ path: "/chatbot", label: "ChatBot", icon: MessageCircle, parent: null }] : []),
    ...(canAccessModule("kds") ? [{ path: "/kds", label: "KDS", icon: ChefHat, parent: null, requiredPlan: "completo" }] : []),
    { path: "/ajuda", label: "Ajuda", icon: LifeBuoy, parent: null },
  ];
  const searchNorm = normalizeSearch(menuSearch);
  const searchResults = searchNorm
    ? searchableItems.filter((it) =>
        normalizeSearch(it.label).includes(searchNorm) ||
        normalizeSearch(it.parent || "").includes(searchNorm)
      )
    : [];

  const isActive = (path) => {
    const currentPath = location.pathname.replace('/admin', '');
    if (path === "/") return currentPath === "/" || currentPath === "";
    // Para /estoque, verificar se é exatamente /estoque (não /estoque/relatorio)
    if (path === "/estoque") {
      return currentPath === "/estoque";
    }
    // Match exato OU prefixo seguido de '/'. Sem isso, /vendas/relatorio casaria com
    // /vendas/relatorio-pagamentos, /vendas/relatorio-produtos, etc — gerando 2 itens
    // selecionados ao mesmo tempo no menu.
    return currentPath === path || currentPath.startsWith(path + '/');
  };

  const isStockControlActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    if (currentPath === "/estoque/relatorio" || currentPath.startsWith("/estoque/relatorio")) return false;
    return ["/estoque", "/compras"].some(path => {
      if (path === "/estoque") {
        return currentPath === "/estoque";
      }
      return currentPath.startsWith(path);
    });
  };

  const isCardapioActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/produtos")
      || currentPath.startsWith("/cardapio/banners");
  };

  const isSalesActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    if (currentPath.startsWith("/vendas/relatorio")) return false;
    return currentPath.startsWith("/vendas");
  };

  const isModulesActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/mesas")
      || currentPath.startsWith("/comandas")
      || currentPath.startsWith("/balcao")
      || currentPath.startsWith("/totem")
      || currentPath.startsWith("/delivery");
  };

  const isRelatoriosActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/relatorios")
      || currentPath.startsWith("/estoque/relatorio")
      || currentPath.startsWith("/vendas/relatorio")
      || currentPath.startsWith("/impulsione/relatorio-ofertas");
  };

  const isClientesFornecedoresActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/clientes-fornecedores");
  };

  const isConfigActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/configuracoes");
  };

  const isFinanceiroActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/financeiro");
  };

  const isImpulsioneVendasActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    if (currentPath.startsWith("/impulsione/relatorio-ofertas")) return false;
    return currentPath.startsWith("/impulsione");
  };

  const isLocalizacaoActive = () => {
    const currentPath = location.pathname.replace('/admin', '');
    return currentPath.startsWith("/localizacao");
  };

  // Helper para wrapping de rotas com PlanGate
  const gated = (path, element) => {
    const required = getRequiredPlan(path);
    if (hasAccess(userPlan, required)) return element;
    return <PlanGateOverlay requiredPlan={required}>{element}</PlanGateOverlay>;
  };

  const isKDS = location.pathname === "/kds" || location.pathname === "/admin/kds";
  const telaBalcao = (
    <div className="relative h-full overflow-hidden" data-e2e="balcao-area"><BalcaoVendas autoAtendimento={false} /></div>
  );
  // Sair do totem (o canto escondido da tela inicial): volta ao Balcão, se a
  // pessoa pode usá-lo; senão, ao início permitido
  const sairDoTotem = () => (canAccessModule("balcao") ? navigate("/balcao") : goHomePermitida());
  const telaTotem = (
    <div data-e2e="totem-area"><BalcaoVendas autoAtendimento setAutoAtendimento={(v) => { if (!v) sairDoTotem(); }} /></div>
  );
  // Clientes do WhatsApp esperando atendimento humano: saiu do sino da tela
  // Delivery (22/09/2026) e passou a valer em qualquer tela do painel.
  const { quantidade: filaAtendimento } = useFilaAtendimento(!isKDS);
  // Anúncios Meta (04/10/2026): anúncio aprovado/reprovado, campanha renovada ou encerrada.
  const { avisos: avisosMeta, naoLidos: avisosMetaNovos } = useAvisosMeta(!isKDS);
  const temAviso = !isKDS && (!!billingAviso || !!trialInfo || filaAtendimento > 0 || avisosMetaNovos > 0);
  const avisoUrgente = Boolean(filaAtendimento > 0 || (billingAviso && billingAviso.nivel !== 'pre') || trialInfo?.expired || (trialInfo?.daysLeft <= 3));
  // Número do sino: fila de atendimento + fatura + trial + avisos Meta novos
  const totalAvisos = isKDS ? 0 : (filaAtendimento || 0) + (billingAviso ? 1 : 0) + (trialInfo ? 1 : 0) + (avisosMetaNovos || 0);
  const isMesas = location.pathname.includes("/mesas");
  const isComandas = location.pathname.includes("/comandas");
  const isDelivery = location.pathname.includes("/delivery");
  const isBalcao = location.pathname.includes("/balcao");
  // Totem: autoatendimento em tela cheia, sem cabeçalho, menu nem faixas
  const isTotem = location.pathname.includes("/totem");
  const isFullscreenTab = isMesas || isComandas || isDelivery || isBalcao;
  // Faixa de Mesas (achado 397): a loja exige caixa aberto e ele está fechado,
  // então o QR recusa todo cliente. Quem diz é o servidor, no polling do
  // chamado de garçom; o estado local do caixa tira a faixa na hora em que ele
  // é aberto por este painel.
  const telaMesas = (
    <Mesas
      setHeaderHidden={setHeaderHidden}
      qrSemCaixa={chamadosGarcom.qrRecusando === "CAIXA_FECHADO" && !caixaAberto}
      onAbrirCaixa={canAccessModule("caixa_abrir") ? () => setAbrirCaixaModalOpen(true) : undefined}
    />
  );

  const telaComandas = <Comandas setHeaderHidden={setHeaderHidden} />;

  return (
    <FiscalProvider>
    <div className="flex h-screen bg-background overflow-hidden">
      {/* Popup global: 30 min antes da abertura, alerta o lojista pra
          se preparar pra vender (toca som a cada 10s ate clicar 'Estou pronto'). */}
      <OpenStorePrompt />
      {/* Mesa chamando o garçom pelo QR: aviso e som em QUALQUER tela do painel,
          porque o atendente raramente está parado na tela de Mesas. */}
      <ChamadoGarcomBanner chamados={chamadosGarcom.chamados} onAtender={chamadosGarcom.atender} />
      {/* Overlay para mobile quando sidebar está aberto */}
      {sidebarOpen && !isKDS && (
        <div
          className={`fixed inset-0 bg-black/70 backdrop-blur-sm z-30 transition-opacity duration-300 ${isFullscreenTab ? '' : 'lg:hidden'}`}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar - Fixo com scroll próprio */}
      <aside className={`
        bg-sidebar text-sidebar-foreground flex-col border-r
        transition-all duration-300 ease-in-out flex-shrink-0
        fixed left-0 top-0 h-screen z-40
        ${isKDS ? 'hidden' : 'flex'}
        ${sidebarOpen
          ? 'w-[85vw] max-w-[320px] lg:w-64 translate-x-0 shadow-2xl lg:shadow-none'
          : isFullscreenTab
            ? '-translate-x-full'
            : '-translate-x-full lg:translate-x-0 lg:w-16 lg:shadow-none'}
      `}>
        {/* Conteúdo do Sidebar */}
        <div className={`${sidebarOpen ? 'block' : 'hidden lg:block'} w-full h-full flex flex-col`}>
          {/* Header do Sidebar - com botão fechar em mobile */}
          <div className="p-4 lg:p-6 border-b flex items-center justify-between flex-shrink-0">
            <div className={`flex items-center gap-3 ${sidebarOpen ? '' : 'lg:justify-center lg:w-full'}`}>
              <button
                onClick={() => {
                  setActiveTopMenu(null);
                  handleSidebarClick("/");
                  setSidebarOpen(false);
                }}
                className="flex-shrink-0 hover:opacity-80 transition-opacity"
                title="Visão Geral"
              >
                <img
                  src={companySettings.logo_url ? `${process.env.REACT_APP_BACKEND_URL || ""}${companySettings.logo_url}` : "/logo-nucleo.png"}
                  alt={companySettings.company_name || "Núcleo"}
                  className="w-12 h-12 lg:w-10 lg:h-10 object-contain rounded-lg"
                  onError={(e) => { e.target.src = "/logo-nucleo.png"; }}
                />
              </button>
              {sidebarOpen && (
                <div className="text-left">
                  <h1 className="text-sidebar-foreground font-bold text-lg lg:text-lg tracking-tight">{companySettings.company_name || "Núcleo"}</h1>
                  <p className="text-xs text-sidebar-muted-foreground">{companySettings.slogan || "o centro da sua gestão"}</p>
                </div>
              )}
            </div>
            {/* Botão fechar - apenas mobile - mais visível */}
            {sidebarOpen && (
              <button 
                onClick={() => setSidebarOpen(false)}
                className="lg:hidden w-10 h-10 flex items-center justify-center rounded-xl bg-sidebar-accent/60 hover:bg-sidebar-accent active:bg-sidebar-accent/80 text-sidebar-foreground transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            )}
          </div>

        <nav className="flex-1 p-3 lg:p-4 space-y-1.5 lg:space-y-1 overflow-y-auto overflow-x-hidden">
          {/* Busca no menu lateral */}
          {sidebarOpen ? (
            <div className="relative mb-2">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-sidebar-muted-foreground pointer-events-none" />
              <input
                type="text"
                value={menuSearch}
                onChange={(e) => {
                  // Só entra texto de quem está com o campo em mãos: autofill
                  // que escreva aqui sem foco é descartado.
                  if (!menuSearchAtiva && document.activeElement !== e.target) return;
                  setMenuSearch(e.target.value);
                }}
                readOnly={!menuSearchAtiva}
                onPointerDown={() => setMenuSearchAtiva(true)}
                onFocus={() => setMenuSearchAtiva(true)}
                onBlur={() => setMenuSearchAtiva(false)}
                placeholder="Buscar aba..."
                // Sem isto o Chrome trata a busca como campo de formulário e
                // despeja autofill aqui quando a página aberta tem cadastro de
                // empresa/endereço (apareceu no Módulo Fiscal). Vale pra
                // qualquer tela futura com formulário, não só aquela.
                autoComplete="off"
                name="nucleo-menu-search"
                className="w-full pl-9 pr-8 py-2 text-sm rounded-lg bg-sidebar-accent/60 border border-sidebar-border text-sidebar-foreground placeholder:text-sidebar-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary/40 transition-all"
              />
              {menuSearch && (
                <button
                  onClick={() => setMenuSearch("")}
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center rounded-md text-sidebar-muted-foreground hover:text-sidebar-foreground hover:bg-sidebar-accent"
                  title="Limpar busca"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              )}
            </div>
          ) : (
            <button
              onClick={() => setSidebarOpen(true)}
              className="w-full flex items-center justify-center py-3 rounded-lg text-sidebar-foreground hover:bg-sidebar-accent transition-colors mb-2"
              title="Buscar aba"
            >
              <Search className="w-5 h-5" strokeWidth={1.5} />
            </button>
          )}

          {/* Resultados da busca */}
          {menuSearch && sidebarOpen && (
            <div className="space-y-1">
              {searchResults.length === 0 ? (
                <div className="px-3 py-6 text-center text-xs text-sidebar-muted-foreground">
                  Nenhuma aba encontrada para "{menuSearch}"
                </div>
              ) : (
                searchResults.map((item) => {
                  const Icon = item.icon;
                  const active = isActive(item.path) && !activeTopMenu;
                  const locked = item.requiredPlan && !hasAccess(userPlan, item.requiredPlan);
                  return (
                    <button
                      key={item.path}
                      onClick={() => {
                        if (item.comingSoon) { handleComingSoonClick(); return; }
                        handleSidebarClick(item.path); setMenuSearch("");
                      }}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/60 hover:bg-sidebar-accent"
                            : "text-sidebar-foreground hover:bg-sidebar-accent"
                      }`}
                    >
                      <Icon className="w-4 h-4 flex-shrink-0" strokeWidth={1.5} />
                      <div className="flex-1 text-left min-w-0">
                        <div className={`truncate flex items-center gap-1.5 ${locked ? "line-through opacity-70" : ""}`}>
                          <span className="truncate">{item.label}</span>
                          {isItemNew(item) && <NewBadge label={item.badgeLabel} variant={item.badgeVariant} />}
                          {(item.path === '/delivery' || item.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                        </div>
                        {item.parent && (
                          <div className="text-[10px] text-sidebar-muted-foreground truncate">{item.parent}</div>
                        )}
                      </div>
                      {locked && <PlanBadge requiredPlan={item.requiredPlan} />}
                    </button>
                  );
                })
              )}
            </div>
          )}

          {/* Estrutura normal do menu (oculta durante busca) */}
          {!menuSearch && (<>
          {/* Tabs Principais (Visão Geral, Indique e Ganhe) — cada uma é uma permissão */}
          {mainTabs.filter((tab) => canAccessModule(tab.moduleKey)).map((tab) => {
            const Icon = tab.icon;
            const active = isActive(tab.path) && !activeTopMenu;
            const locked = tab.requiredPlan && !hasAccess(userPlan, tab.requiredPlan);
            return (
              <button
                key={tab.path}
                onClick={() => tab.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(tab.requiredPlan) : handleSidebarClick(tab.path)}
                className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                  tab.comingSoon
                    ? "text-sidebar-foreground/50 cursor-not-allowed"
                    : active
                    ? "bg-primary text-primary-foreground font-medium shadow-lg"
                    : locked
                      ? "text-sidebar-foreground/40 cursor-not-allowed"
                      : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                } ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
                title={!sidebarOpen ? tab.label : (tab.comingSoon ? "Em breve" : locked ? `Disponível no plano ${getPlanLabel(tab.requiredPlan)}` : tab.label)}
              >
                <Icon className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
                {sidebarOpen && (
                  <>
                    <span className={`text-base lg:text-sm font-medium flex-1 text-left ${tab.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{tab.label}</span>
                    {isItemNew(tab) && <NewBadge label={tab.badgeLabel} variant={tab.badgeVariant} />}
                    {locked && !tab.comingSoon && <PlanBadge requiredPlan={tab.requiredPlan} />}
                  </>
                )}
              </button>
            );
          })}

          {/* Cardápio (Hierárquico) */}
          {cardapioModule.children.length > 0 && (
          <div>
            <button
              onClick={() => moduleLocks.cardapio.fullyLocked ? handleLockedClick(moduleLocks.cardapio.requiredPlan) : handleModuleClick(setCardapioExpanded, cardapioExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isCardapioActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.cardapio.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? cardapioModule.label : ''}
            >
              <UtensilsCrossed className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.cardapio.fullyLocked ? "line-through opacity-70" : ""}`}>{cardapioModule.label}</span>{moduleLocks.cardapio.fullyLocked && <PlanBadge requiredPlan={moduleLocks.cardapio.requiredPlan} />}
                  {cardapioExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {sidebarOpen && cardapioExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {cardapioModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Módulos (Mesas / Balcão / Delivery) — só no mobile */}
          {modulesModule.children.length > 0 && (
          <div className="md:hidden">
            <button
              onClick={() => moduleLocks.modules.fullyLocked ? handleLockedClick(moduleLocks.modules.requiredPlan) : handleModuleClick(setModulesExpanded, modulesExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isModulesActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.modules.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? modulesModule.label : ''}
            >
              <LayoutGrid className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.modules.fullyLocked ? "line-through opacity-70" : ""}`}>{modulesModule.label}</span>{moduleLocks.modules.fullyLocked && <PlanBadge requiredPlan={moduleLocks.modules.requiredPlan} />}
                  {modulesExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>
            {sidebarOpen && modulesExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {modulesModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path);
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Controle de Estoque (Hierárquico) */}
          {stockControlModule.children.length > 0 && (
          <div>
            {/* Header do módulo */}
            <button
              onClick={() => moduleLocks.stock.fullyLocked ? handleLockedClick(moduleLocks.stock.requiredPlan) : handleModuleClick(setStockControlExpanded, stockControlExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isStockControlActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.stock.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? stockControlModule.label : ''}
            >
              <BarChart3 className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.stock.fullyLocked ? "line-through opacity-70" : ""}`}>{stockControlModule.label}</span>{moduleLocks.stock.fullyLocked && <PlanBadge requiredPlan={moduleLocks.stock.requiredPlan} />}
                  {stockControlExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {/* Sub-itens */}
            {sidebarOpen && stockControlExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {stockControlModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Impulsione suas Vendas (Hierárquico) */}
          {impulsioneVendasModule.children.length > 0 && (
          <div>
            <button
              onClick={() => moduleLocks.impulsione.fullyLocked ? handleLockedClick(moduleLocks.impulsione.requiredPlan) : handleModuleClick(setImpulsioneVendasExpanded, impulsioneVendasExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isImpulsioneVendasActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.impulsione.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? impulsioneVendasModule.label : ''}
            >
              <Megaphone className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.impulsione.fullyLocked ? "line-through opacity-70" : ""}`}>{impulsioneVendasModule.label}</span>{moduleLocks.impulsione.fullyLocked && <PlanBadge requiredPlan={moduleLocks.impulsione.requiredPlan} />}
                  {impulsioneVendasExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {sidebarOpen && impulsioneVendasExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {impulsioneVendasModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Vendas (Hierárquico) */}
          {salesModule.children.length > 0 && (
          <div>
            {/* Header do módulo */}
            <button
              onClick={() => moduleLocks.sales.fullyLocked ? handleLockedClick(moduleLocks.sales.requiredPlan) : handleModuleClick(setSalesExpanded, salesExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isSalesActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.sales.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? salesModule.label : ''}
            >
              <DollarSign className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.sales.fullyLocked ? "line-through opacity-70" : ""}`}>{salesModule.label}</span>{moduleLocks.sales.fullyLocked && <PlanBadge requiredPlan={moduleLocks.sales.requiredPlan} />}
                  {salesExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {/* Sub-itens de Vendas */}
            {sidebarOpen && salesExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {salesModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Relatórios (Hierárquico) */}
          {relatoriosModule.children.length > 0 && (
          <div>
            <button
              onClick={() => moduleLocks.relatorios.fullyLocked ? handleLockedClick(moduleLocks.relatorios.requiredPlan) : handleModuleClick(setRelatoriosExpanded, relatoriosExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isRelatoriosActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.relatorios.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? relatoriosModule.label : ''}
            >
              <PieChart className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.relatorios.fullyLocked ? "line-through opacity-70" : ""}`}>{relatoriosModule.label}</span>{moduleLocks.relatorios.fullyLocked && <PlanBadge requiredPlan={moduleLocks.relatorios.requiredPlan} />}
                  {relatoriosExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {sidebarOpen && relatoriosExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {relatoriosModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Clientes e Fornecedores (Hierárquico) */}
          {clientesFornecedoresModule.children.length > 0 && (
          <div>
            <button
              onClick={() => moduleLocks.pessoas.fullyLocked ? handleLockedClick(moduleLocks.pessoas.requiredPlan) : handleModuleClick(setClientesFornecedoresExpanded, clientesFornecedoresExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isClientesFornecedoresActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.pessoas.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? clientesFornecedoresModule.label : ''}
            >
              <Users className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.pessoas.fullyLocked ? "line-through opacity-70" : ""}`}>{clientesFornecedoresModule.label}</span>{moduleLocks.pessoas.fullyLocked && <PlanBadge requiredPlan={moduleLocks.pessoas.requiredPlan} />}
                  {clientesFornecedoresExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {sidebarOpen && clientesFornecedoresExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {clientesFornecedoresModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Financeiro (Hierárquico) */}
          {financeiroModule.children.length > 0 && (
          <div>
            <button
              onClick={() => moduleLocks.financeiro.fullyLocked ? handleLockedClick(moduleLocks.financeiro.requiredPlan) : handleModuleClick(setFinanceiroExpanded, financeiroExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isFinanceiroActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.financeiro.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? financeiroModule.label : ''}
            >
              <Wallet className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.financeiro.fullyLocked ? "line-through opacity-70" : ""}`}>{financeiroModule.label}</span>{moduleLocks.financeiro.fullyLocked && <PlanBadge requiredPlan={moduleLocks.financeiro.requiredPlan} />}
                  {financeiroExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {sidebarOpen && financeiroExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {financeiroModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Localização (Hierárquico) */}
          {localizacaoModule.children.length > 0 && (
          <div>
            <button
              onClick={() => moduleLocks.localizacao.fullyLocked ? handleLockedClick(moduleLocks.localizacao.requiredPlan) : handleModuleClick(setLocalizacaoExpanded, localizacaoExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isLocalizacaoActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.localizacao.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? localizacaoModule.label : ''}
            >
              <MapPin className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.localizacao.fullyLocked ? "line-through opacity-70" : ""}`}>{localizacaoModule.label}</span>{moduleLocks.localizacao.fullyLocked && <PlanBadge requiredPlan={moduleLocks.localizacao.requiredPlan} />}
                  {localizacaoExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {sidebarOpen && localizacaoExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {localizacaoModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Configurações (Hierárquico) */}
          {configModule.children.length > 0 && (
          <div>
            {/* Header do módulo */}
            <button
              onClick={() => moduleLocks.config.fullyLocked ? handleLockedClick(moduleLocks.config.requiredPlan) : handleModuleClick(setConfigExpanded, configExpanded)}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isConfigActive() && !activeTopMenu
                  ? "bg-primary/10 text-primary font-medium"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${moduleLocks.config.fullyLocked ? 'cursor-not-allowed opacity-50 hover:bg-transparent' : ''} ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? configModule.label : ''}
            >
              <Settings className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <>
                  <span className={`text-base lg:text-sm flex-1 text-left ${moduleLocks.config.fullyLocked ? "line-through opacity-70" : ""}`}>{configModule.label}</span>{moduleLocks.config.fullyLocked && <PlanBadge requiredPlan={moduleLocks.config.requiredPlan} />}
                  {configExpanded ? (
                    <ChevronDown className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  ) : (
                    <ChevronRight className="w-5 h-5 lg:w-4 lg:h-4" strokeWidth={1.5} />
                  )}
                </>
              )}
            </button>

            {/* Sub-itens de Configurações */}
            {sidebarOpen && configExpanded && (
              <div className="ml-4 mt-1 space-y-1 border-l-2 border-sidebar-border pl-4">
                {configModule.children.map((child) => {
                  const ChildIcon = child.icon;
                  const active = isActive(child.path) && !activeTopMenu;
                  const locked = child.requiredPlan && !hasAccess(userPlan, child.requiredPlan);
                  return (
                    <button
                      key={child.path}
                      onClick={() => child.comingSoon ? handleComingSoonClick() : locked ? handleLockedClick(child.requiredPlan) : handleSidebarClick(child.path)}
                      className={`w-full flex items-center gap-3 px-3 py-3 lg:py-2 rounded-lg transition-all duration-200 text-base lg:text-sm ${
                        active
                          ? "bg-primary text-primary-foreground font-medium"
                          : locked
                            ? "text-sidebar-foreground/40 cursor-not-allowed"
                            : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                      }`}
                    >
                      <ChildIcon className="w-5 h-5 lg:w-4 lg:h-4 flex-shrink-0" strokeWidth={1.5} />
                      <span className={`flex-1 text-left ${child.comingSoon ? "opacity-60" : locked ? "line-through opacity-70" : ""}`}>{child.label}</span>
                      {isItemNew(child) && <NewBadge label={child.badgeLabel} variant={child.badgeVariant} />}
                      {(child.path === '/delivery' || child.path === '/vendas/pedidos') && <AgendadosCountBadge count={agendadosCount} />}
                      {locked && !child.comingSoon && <PlanBadge requiredPlan={child.requiredPlan} />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          )}

          {/* Assinatura — abaixo de Configurações. Visível para quem tem permissão Configurações. */}
          {canAccessModule("configuracoes") && (
            <button
              onClick={() => handleSidebarClick('/assinatura')}
              className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                isActive('/assinatura') && !activeTopMenu
                  ? "bg-primary text-primary-foreground font-medium shadow-lg"
                  : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
              } ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
              title={!sidebarOpen ? 'Assinatura' : ''}
            >
              <Wallet className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
              {sidebarOpen && (
                <span className="text-base lg:text-sm font-medium flex-1 text-left">Assinatura</span>
              )}
            </button>
          )}

          {/* ChatBot — dono, administrador ou funcionário com a permissão ChatBot */}
          {podeChatbot && (
          <button
            onClick={() => handleSidebarClick('/chatbot')}
            className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
              isActive('/chatbot') && !activeTopMenu
                ? "bg-primary text-primary-foreground font-medium shadow-lg"
                : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
            } ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
            title={!sidebarOpen ? 'ChatBot' : ''}
          >
            <WhatsAppIcon className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" />
            {sidebarOpen && (
              <span className="text-base lg:text-sm font-medium flex-1 text-left">ChatBot</span>
            )}
          </button>
          )}

          {/* KDS - ultima aba da lista */}
          {canAccessModule("kds") && (() => {
            const kdsLocked = !hasAccess(userPlan, "completo");
            const kdsActive = isActive('/kds') && !activeTopMenu;
            return (
              <button
                onClick={() => kdsLocked ? handleLockedClick("enterprise") : handleSidebarClick('/kds')}
                className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
                  kdsActive
                    ? "bg-primary text-primary-foreground font-medium shadow-lg"
                    : kdsLocked
                      ? "text-sidebar-foreground/40 cursor-not-allowed"
                      : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
                } ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
                title={!sidebarOpen ? 'KDS' : (kdsLocked ? 'Disponível no plano Completo' : 'KDS')}
              >
                <ChefHat className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
                {sidebarOpen && (
                  <>
                    <span className={`text-base lg:text-sm font-medium flex-1 text-left ${kdsLocked ? "line-through opacity-70" : ""}`}>KDS</span>
                    {kdsLocked && <PlanBadge requiredPlan="completo" />}
                  </>
                )}
              </button>
            );
          })()}
          </>)}

          {/* Ajuda — sempre por último e visível pra TODOS os papéis e planos.
              Fica fora do map dos módulos de propósito: ajuda não se bloqueia
              por permissão nem por plano. */}
          <button
            onClick={() => handleSidebarClick('/ajuda')}
            className={`w-full flex items-center gap-3 lg:gap-3 px-4 py-4 lg:py-3 rounded-xl lg:rounded-lg transition-all duration-200 ${
              isActive('/ajuda') && !activeTopMenu
                ? "bg-primary text-primary-foreground font-medium shadow-lg"
                : "text-sidebar-foreground hover:bg-sidebar-accent active:bg-sidebar-accent/80"
            } ${!sidebarOpen ? 'lg:justify-center lg:px-2' : ''}`}
            title={!sidebarOpen ? 'Ajuda' : ''}
          >
            <LifeBuoy className="w-6 h-6 lg:w-5 lg:h-5 flex-shrink-0" strokeWidth={1.5} />
            {sidebarOpen && (
              <span className="text-base lg:text-sm font-medium flex-1 text-left">Ajuda</span>
            )}
          </button>
        </nav>

        {/* Versão do Sistema - esconder no Electron (aparece no badge do Electron).
            O rodapé só existe por causa dela: o card "Plano atual" saiu em 23/10/2026. */}
        {!window.nucleoDesktop && (
          <div className="p-3 lg:p-4 border-t border-sidebar-border flex-shrink-0">
            <button
              onClick={() => setVersionDialogOpen(true)}
              className={`w-full flex items-center justify-center gap-2 px-3 py-2 text-xs text-sidebar-muted-foreground hover:text-sidebar-foreground transition-colors ${sidebarOpen ? '' : 'lg:px-2'}`}
              title="Ver histórico de versões"
            >
              {sidebarOpen ? (
                <>
                  <Info className="w-3 h-3" />
                  <span>v{versionInfo.current}</span>
                </>
              ) : (
                <Info className="w-4 h-4" title={`v${versionInfo.current}`} />
              )}
            </button>
          </div>
        )}
        </div>
      </aside>

      {/* Espaçador para compensar o sidebar fixo - apenas desktop */}
      {!isKDS && !isFullscreenTab && <div className={`flex-shrink-0 transition-all duration-300 hidden lg:block ${sidebarOpen ? 'lg:w-64' : 'lg:w-16'}`}></div>}

      {/* Conteúdo Principal */}
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
        {/* Faixa de mensalidade vencida: largura total, sem fechar; some quando a fatura é paga */}
        {!isKDS && !isTotem && (
          <FaixaMensalidadeVencida
            aviso={billingAviso}
            naAssinatura={location.pathname.startsWith("/assinatura")}
            onPagar={() => handleSidebarClick("/assinatura")}
          />
        )}
        {/* Simulador de balança (26/10/2026): só com o simulador ligado neste computador
            (aparece também no Totem, para testar a balança de lá) */}
        <SimuladorFlutuante />
        <AlertDialog open={confirmarTotem} onOpenChange={setConfirmarTotem}>
          <AlertDialogContent data-e2e="confirmar-totem">
            <AlertDialogHeader>
              <AlertDialogTitle>Abrir o modo Totem?</AlertDialogTitle>
              <AlertDialogDescription>
                A tela fica em tela cheia para o cliente fazer o pedido sozinho. Para sair, toque no canto
                superior esquerdo da tela inicial do totem.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-e2e="confirmar-totem-nao">Cancelar</AlertDialogCancel>
              <AlertDialogAction data-e2e="confirmar-totem-sim" onClick={() => {
                setSidebarOpen(false);
                setActiveTopMenu("totem");
                activeTopMenuRef.current = "totem";
                navigate("/totem");
              }}>Abrir Totem</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
        {/* Header com Botão Hamburguer e Mini Menu - Fixo */}
        <header className={`bg-card border-b flex items-stretch flex-shrink-0 sticky top-0 z-30 ${isKDS || headerHidden || isTotem ? 'hidden' : ''}`}>
          {/* Área do logo/hamburger - responsivo */}
          {/* Mesma largura com o menu aberto ou recolhido: o menu lateral já ocupa
              o espaço dele à esquerda; alargar esta coluna junto deixava o ☰
              sozinho no meio de 256 px vazios. */}
          <div className={`flex items-center justify-center border-r transition-all duration-300 ${isFullscreenTab ? 'w-auto px-1.5 sm:px-3' : 'w-14 lg:w-16'}`}>
            {isFullscreenTab ? (
              <div className="flex items-center gap-1">
                {/* Celular: sem o logo (o ☰ já leva ao menu) — sobrava pouco
                    espaço pras abas e o "Delivery" ficava cortado (25/09/2026) */}
                <button
                  onClick={() => {
                    setActiveTopMenu(null);
                    usingSidebarMenuRef.current = true;
                    sidebarNavigationRef.current = true;
                    setIsSidebarActive(true);
                    navigate("/");
                  }}
                  className="hidden sm:block hover:opacity-80 transition-opacity"
                  title="Visão Geral"
                >
                  <img
                    src={companySettings.logo_url ? `${process.env.REACT_APP_BACKEND_URL || ""}${companySettings.logo_url}` : "/logo-nucleo.png"}
                    alt={companySettings.company_name || "Núcleo"}
                    className="w-9 h-9 object-contain rounded-lg"
                    onError={(e) => { e.target.src = "/logo-nucleo.png"; }}
                  />
                </button>
                <button
                  onClick={() => setSidebarOpen(true)}
                  className="w-10 h-10 sm:w-auto sm:h-auto sm:p-1 flex items-center justify-center hover:bg-muted rounded-md transition-colors"
                  title="Abrir menu"
                >
                  <Menu className="w-6 h-6 sm:w-4 sm:h-4 text-muted-foreground" />
                </button>
              </div>
            ) : (
              <Button
                onClick={toggleSidebar}
                size="icon"
                variant="ghost"
                className="flex-shrink-0 w-10 h-10 lg:w-9 lg:h-9"
                title={sidebarOpen ? "Recolher menu" : "Abrir menu"}
              >
                <Menu className="w-6 h-6 lg:w-5 lg:h-5" />
              </Button>
            )}
          </div>

          {/* Logo do Núcleo no centro — some sozinha quando não cabe */}
          <LogoCentralCabecalho esquerdaRef={abasCabecalhoRef} direitaRef={acoesCabecalhoRef} />

          {/* Mini Menu com ícones */}
          {/* No celular a fileira rola para o lado: a borda direita esmaece para
              mostrar que há mais módulos (antes o último parecia cortado) */}
          <div ref={abasCabecalhoRef} className="flex-1 min-w-0 flex items-center px-1.5 sm:px-4 py-2 gap-1.5 sm:gap-2 overflow-x-auto scrollbar-hide [mask-image:linear-gradient(to_right,black_calc(100%-28px),transparent)] lg:[mask-image:none]">
            {topMenuItems.filter(item => !item.hidden && canAccessModule(item.moduleKey)).map((item) => {
              const IconComponent = item.icon;
              let currentPath = location.pathname;
              if (currentPath.startsWith('/admin')) {
                currentPath = currentPath.replace('/admin', '') || '/';
              }
              const itemRelativePath = item.path.startsWith('/') ? item.path : `/${item.path}`;
              const isActive = activeTopMenu === item.id || currentPath === itemRelativePath || currentPath.startsWith(itemRelativePath + '/');
              const itemLocked = item.requiredPlan && !hasAccess(userPlan, item.requiredPlan);
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    if (itemLocked) {
                      handleLockedClick(item.requiredPlan);
                      return;
                    }
                    if (item.id === "totem") { setConfirmarTotem(true); return; }
                    logger.debug('🧭 Menu superior clicado:', item.id, '->', item.path);
                    usingSidebarMenuRef.current = false;
                    sidebarNavigationRef.current = false;
                    setIsSidebarActive(false);
                    setActiveTopMenu(item.id);
                    activeTopMenuRef.current = item.id;
                    setSidebarOpen(false);
                    const targetPath = item.path.startsWith('/') ? item.path : `/${item.path}`;
                    logger.debug('🧭 Navegando para:', targetPath);
                    navigate(targetPath, { replace: false });
                  }}
                  className={`
                    ${item.hideOnMobile ? 'hidden md:flex' : 'flex'} flex-col items-center justify-center gap-1 px-1 py-2 sm:py-2 rounded-lg font-medium text-xs sm:text-xs whitespace-nowrap
                    transition-all duration-200 w-[64px] sm:w-[84px] flex-shrink-0
                    ${isActive
                      ? 'bg-primary text-primary-foreground shadow-md'
                      : itemLocked
                        ? 'bg-muted/40 cursor-not-allowed opacity-60'
                        : 'bg-muted hover:bg-muted/80 active:bg-muted/60'
                    }
                  `}
                  title={itemLocked ? `Disponível no plano ${getPlanLabel(item.requiredPlan)}` : item.label}
                >
                  {/* Mesmo tamanho para todos (dono, 25/10/2026): os módulos têm o mesmo peso */}
                  <IconComponent className="w-[22px] h-[22px] shrink-0" />
                  <div className="flex items-center gap-1">
                    <span className={`text-[10px] sm:text-xs ${itemLocked ? "line-through" : ""}`}>{item.label}</span>
                    {itemLocked && (
                      <PlanBadge requiredPlan={item.requiredPlan} className="text-[7px] px-1 py-0" />
                    )}
                  </div>
                </button>
              );
            })}
          </div>

          <div ref={acoesCabecalhoRef} className="flex items-center gap-1 pr-2 sm:pr-4 flex-shrink-0">
            {/* Switch IA do ChatBot — requer acesso ao módulo Configurações.
                Reflete e altera a flag de Resposta Automática (IA) do WhatsApp Bot. */}
            {canAccessModule("configuracoes") && (
              <button
                onClick={handleToggleBot}
                disabled={botToggleLoading}
                className={`flex items-center gap-1.5 p-2.5 sm:px-2.5 sm:py-1.5 rounded-lg text-xs font-semibold transition-all ${
                  botAutoReply && botConnected
                    ? 'bg-green-500/10 text-green-600 dark:text-green-400 hover:bg-green-500/20'
                    : 'bg-red-500/10 text-red-600 dark:text-red-400 hover:bg-red-500/20'
                }`}
                title={
                  !botConnected
                    ? "WhatsApp não conectado — abra ChatBot pra conectar"
                    : botAutoReply
                      ? "IA respondendo automaticamente — clique para desativar"
                      : "IA desativada — clique para ativar respostas automáticas"
                }
              >
                <Bot className="w-5 h-5 sm:w-4 sm:h-4" strokeWidth={2} />
                <div className={`hidden sm:block relative w-8 h-4 rounded-full transition-colors ${botAutoReply && botConnected ? 'bg-green-500' : 'bg-red-500'}`}>
                  <div className={`absolute top-0.5 w-3 h-3 rounded-full bg-white shadow-sm transition-transform ${botAutoReply && botConnected ? 'translate-x-4' : 'translate-x-0.5'}`} />
                </div>
              </button>
            )}

            {/* Switch Aberto/Fechado — requer acesso ao módulo Configurações */}
            {canAccessModule("configuracoes") && (
            <button
              onClick={handleStoreClick}
              disabled={storeToggleLoading}
              className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                storeOpen
                  ? 'bg-green-500/10 text-green-600 dark:text-green-400 hover:bg-green-500/20'
                  : 'bg-red-500/10 text-red-600 dark:text-red-400 hover:bg-red-500/20'
              }`}
              title={storeOpen ? "Loja aberta - clique para fechar" : "Loja fechada - clique para abrir"}
            >
              <div className={`relative w-8 h-4 rounded-full transition-colors ${storeOpen ? 'bg-green-500' : 'bg-red-500'}`}>
                <div className={`absolute top-0.5 w-3 h-3 rounded-full bg-white shadow-sm transition-transform ${storeOpen ? 'translate-x-4' : 'translate-x-0.5'}`} />
              </div>
              <span className="hidden sm:inline">{storeOpen ? 'Aberto' : storeCountdown ? storeCountdown : 'Fechado'}</span>
            </button>
            )}
            {/* Caixa, App download e Recarregar — escondidos no mobile */}
            <div className="hidden md:flex items-center gap-1">
              {(() => {
                // Sem a permissão (Pessoas › Funcionários), o botão vira só o
                // aviso do estado do caixa — o servidor recusaria a ação.
                if (!caixaAberto && !caixaConhecido) {
                  return <Skeleton className="h-8 w-28 rounded-md" data-e2e="caixa-carregando" />;
                }
                if (caixaAberto) {
                  return canAccessModule("caixa_fechar") ? (
                    <Button variant="ghost" size="sm" className="text-xs gap-1 text-green-600 dark:text-green-400"
                      onClick={() => setFecharCaixaModalOpen(true)}>
                      <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                      Caixa Aberto
                    </Button>
                  ) : (
                    <span className="text-xs flex items-center gap-1 px-2 text-green-600 dark:text-green-400" title="Você não tem permissão para fechar o caixa">
                      <span className="w-2 h-2 rounded-full bg-green-500" />Caixa Aberto
                    </span>
                  );
                }
                return canAccessModule("caixa_abrir") ? (
                  <Button size="sm" className="text-xs gap-1 bg-orange-500 hover:bg-orange-600 text-white"
                    onClick={() => setAbrirCaixaModalOpen(true)}>
                    <DollarSign className="w-4 h-4" />
                    Abrir Caixa
                  </Button>
                ) : (
                  <span className="text-xs px-2 text-muted-foreground" title="Você não tem permissão para abrir o caixa">Caixa fechado</span>
                );
              })()}
              {/* Suporte: menu com WhatsApp (time) e CLEO (em breve). Plano da CLEO
                  em docs/features/cleo-suporte/. */}
              <SuporteMenu />
              {/* Avaliacao mensal — so na janela (dia 01 ao 05) e fora do teste */}
              {avaliacao?.mostrar && (
                <button
                  onClick={() => setAvaliacaoAberta(true)}
                  className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-bold text-white bg-orange-500 hover:bg-orange-600 transition-all animate-pulse"
                  title="Avaliar o Núcleo — leva 20 segundos"
                >
                  <Sparkles className="w-4 h-4" />
                  <span className="hidden sm:inline">Avaliar</span>
                </button>
              )}
              {!window.nucleoDesktop && (
                <a
                  href="https://usenucleo.com.br/downloads/Nucleo-Setup.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
                  title="Baixar app desktop"
                >
                  <Download className="w-4 h-4" />
                  <span className="hidden sm:inline">App</span>
                </a>
              )}
              {/* Botão Recarregar — no app desktop o F5 faz isso (Núcleo Desktop 1.0.598+) */}
              {!window.nucleoDesktop?.recarregaComF5 && (
                <button
                  onClick={() => window.location.reload()}
                  className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
                  title="Recarregar página"
                >
                  <RefreshCw className="w-4 h-4" />
                </button>
              )}
            </div>
            {avaliacaoAberta && avaliacao?.perguntas && (
        <AvaliacaoMensal
          perguntas={avaliacao.perguntas}
          onClose={() => setAvaliacaoAberta(false)}
          onEnviado={() => setAvaliacao({ ...avaliacao, mostrar: false, ja_respondeu: true })}
        />
      )}
      {/* Notificações — só no desktop (no mobile fica dentro do menu de perfil) */}
            <div className="relative hidden md:block" ref={notificationsRef}>
              <SinoNotificacoes
                total={totalAvisos}
                urgente={avisoUrgente && totalAvisos > 0}
                onClick={() => setNotificationsOpen(!notificationsOpen)}
                title={filaAtendimento > 0 && !isKDS ? `${filaAtendimento} cliente(s) aguardando atendimento` : "Notificações"}
              />
              {notificationsOpen && (
                <div className="absolute right-0 top-full mt-2 w-80 bg-card border rounded-xl shadow-xl z-50 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                  <div className="px-4 py-3 border-b">
                    <p className="text-sm font-semibold">Notificações</p>
                  </div>
                  {!isKDS && <ListaFilaAtendimento />}
                  {!isKDS && <ListaAvisosMeta aoFechar={() => setNotificationsOpen(false)} />}
                  {renderBillingAviso(() => setNotificationsOpen(false))}
                  {trialInfo && !isKDS ? (
                    <div className={`px-4 py-3 text-sm ${
                      trialInfo.expired
                        ? 'bg-red-500/10 text-red-600 dark:text-red-400'
                        : trialInfo.daysLeft <= 3
                          ? 'bg-amber-500/10 text-amber-700 dark:text-amber-400'
                          : 'bg-orange-500/10 text-orange-600 dark:text-orange-400'
                    }`}>
                      {trialInfo.expired ? (
                        <>
                          <p className="font-medium mb-1">Periodo de teste expirou</p>
                          <a href="https://usenucleo.com.br/#planos" target="_blank" rel="noopener noreferrer" className="underline font-bold">Assinar agora</a>
                        </>
                      ) : (
                        <>
                          <p className="font-medium mb-1">Teste gratis: {trialInfo.daysLeft} {trialInfo.daysLeft === 1 ? 'dia restante' : 'dias restantes'}</p>
                          <a href="https://usenucleo.com.br/#planos" target="_blank" rel="noopener noreferrer" className="underline">Ver planos</a>
                        </>
                      )}
                    </div>
                  ) : !billingAviso && !filaAtendimento && avisosMeta.length === 0 ? (
                    <div className="px-4 py-6 text-sm text-muted-foreground text-center">
                      Nenhuma notificação
                    </div>
                  ) : null}
                </div>
              )}
            </div>
            {/* Menu de Perfil do Restaurante */}
            <div className="relative" ref={profileMenuRef}>
              <button
                onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                className={`relative w-10 h-10 rounded-full overflow-hidden border-2 transition-colors flex-shrink-0 ${profileMenuOpen ? 'border-primary shadow-lg' : 'border-primary/30 hover:border-primary'}`}
                title={companySettings.company_name || "Menu do restaurante"}
              >
                <img
                  src={companySettings.logo_url ? `${process.env.REACT_APP_BACKEND_URL || ""}${companySettings.logo_url}` : "/logo-nucleo.png"}
                  alt={companySettings.company_name || "Restaurante"}
                  className="w-full h-full object-cover"
                  onError={(e) => { e.target.src = "/logo-nucleo.png"; }}
                />
                {/* Dot de notificação — apenas no mobile (no desktop o sino mostra) */}
                {temAviso && totalAvisos > 0 && (
                  <span className={`md:hidden absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full ring-2 ring-background text-white text-[10px] font-bold tabular-nums flex items-center justify-center ${avisoUrgente ? 'bg-red-500 animate-pulse motion-reduce:animate-none' : 'bg-primary'}`}>
                    {totalAvisos > 99 ? '99+' : totalAvisos}
                  </span>
                )}
              </button>
              {profileMenuOpen && (
                <div className="absolute right-0 top-full mt-2 w-64 bg-card border rounded-xl shadow-xl z-50 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                  {/* Nome do restaurante */}
                  <div className="px-4 py-3 border-b">
                    <p className="text-sm font-semibold truncate">{companySettings.company_name || "Restaurante"}</p>
                    <p className="text-xs text-muted-foreground truncate">{companySettings.slogan || ""}</p>
                  </div>
                  {/* Notificações — só no mobile (no desktop tem sino separado) */}
                  <div className="md:hidden border-b">
                    <div className="px-4 pt-3 pb-1.5 flex items-center gap-2">
                      <Bell className="w-3.5 h-3.5 text-muted-foreground" />
                      <p className="text-[11px] uppercase tracking-wider font-bold text-muted-foreground">Notificações</p>
                    </div>
                    {!isKDS && <ListaFilaAtendimento />}
                    {!isKDS && <ListaAvisosMeta aoFechar={() => setProfileMenuOpen(false)} />}
                    {renderBillingAviso(() => setProfileMenuOpen(false))}
                    {trialInfo && !isKDS ? (
                      <div className={`mx-3 mb-3 px-3 py-2 rounded-lg text-xs ${
                        trialInfo.expired
                          ? 'bg-red-500/10 text-red-600 dark:text-red-400'
                          : trialInfo.daysLeft <= 3
                            ? 'bg-amber-500/10 text-amber-700 dark:text-amber-400'
                            : 'bg-orange-500/10 text-orange-600 dark:text-orange-400'
                      }`}>
                        {trialInfo.expired ? (
                          <>
                            <p className="font-medium mb-1">Período de teste expirou</p>
                            <a href="https://usenucleo.com.br/#planos" target="_blank" rel="noopener noreferrer" className="underline font-bold">Assinar agora</a>
                          </>
                        ) : (
                          <>
                            <p className="font-medium mb-1">Teste grátis: {trialInfo.daysLeft} {trialInfo.daysLeft === 1 ? 'dia restante' : 'dias restantes'}</p>
                            <a href="https://usenucleo.com.br/#planos" target="_blank" rel="noopener noreferrer" className="underline">Ver planos</a>
                          </>
                        )}
                      </div>
                    ) : !billingAviso && !filaAtendimento && avisosMeta.length === 0 ? (
                      <div className="px-4 pb-3 text-xs text-muted-foreground">
                        Nenhuma notificação
                      </div>
                    ) : null}
                  </div>
                  {/* Configurações */}
                  <button
                    onClick={() => {
                      setProfileMenuOpen(false);
                      usingSidebarMenuRef.current = true;
                      sidebarNavigationRef.current = true;
                      setIsSidebarActive(true);
                      setActiveTopMenu(null);
                      // /admin/configuracoes não tem rota: a área ficava em branco (achado 141)
                      navigate("/admin/configuracoes/sistema");
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-muted transition-colors"
                  >
                    <Settings className="w-4 h-4 text-muted-foreground" />
                    Configurações
                  </button>
                  {/* Tema */}
                  <button
                    onClick={toggleDarkMode}
                    className="w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-muted transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      {darkMode ? <Moon className="w-4 h-4 text-muted-foreground" /> : <Sun className="w-4 h-4 text-muted-foreground" />}
                      <span className="flex flex-col items-start leading-tight">
                        Meu tema
                        <span className="text-[11px] text-muted-foreground">só para você</span>
                      </span>
                    </div>
                    <div className={`relative w-10 h-5 rounded-full transition-colors ${darkMode ? 'bg-primary' : 'bg-muted-foreground/30'}`}>
                      <div className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-transform flex items-center justify-center ${darkMode ? 'translate-x-5' : 'translate-x-0.5'}`}>
                        {darkMode ? <Moon className="w-2.5 h-2.5 text-primary" /> : <Sun className="w-2.5 h-2.5 text-amber-500" />}
                      </div>
                    </div>
                  </button>
                  <div className="border-t" />
                  {/* Sair */}
                  <button
                    onClick={() => {
                      setProfileMenuOpen(false);
                      handleLogout();
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-destructive/10 text-destructive transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    Sair
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Conteúdo das Rotas — min-h-0 + min-w-0 é o fix do bug "scroll duplo":
            sem isso, flex children herdam min-height/min-width: auto (tamanho
            do conteúdo) e ignoram o overflow-auto, fazendo o main estourar e
            criar scroll do body. Com min-h-0/min-w-0, o flex respeita o limite
            do espaço disponível e o overflow-auto só ativa quando realmente
            necessário — cada página gerencia o seu, sem duplicação. */}
        <main className="flex-1 min-h-0 min-w-0 overflow-x-hidden overflow-y-auto" key={`main-${activeTopMenu || 'null'}-${location.pathname}`}>
          {/* Deploy novo com esta aba ainda no bundle antigo: faixa pedindo pra
              atualizar (a aba fica aberta o dia todo e o SPA nao recarrega sozinho). */}
          <BannerAtualizacao />
          <Routes>
            {/* Rotas do Menu Superior - Links Explícitos (URLs diretas) */}
            {/* Com rotas aninhadas, quando navegamos para /mesas, o path relativo é vazio, então usamos index */}
            {/* Mas também precisamos capturar quando há sub-rotas, então usamos ambos */}
            <Route index element={
              (() => {
                // Determinar qual componente renderizar baseado no pathname completo
                const path = location.pathname;
                logger.debug('🔵 Renderizando rota index, pathname:', path);
                if (path.includes('/cardapio-admin')) return <CardapioPublico onLoginClick={() => setActiveTopMenu(null)} />;
                if (path.includes('/mesas')) return gated("/mesas", telaMesas);
                if (path.includes('/comandas')) return gated("/comandas", telaComandas);
                if (path.includes('/balcao')) return gated("/balcao", telaBalcao);
                if (path.includes('/totem')) return gated("/totem", telaTotem);
                // Sem a permissão ChatBot o guard redireciona — não montar a tela
                // (mesma razão da Visão Geral: evita disparar requests antes de
                // ser redirecionado). v1.5.406
                if (path.includes('/chatbot')) return podeChatbot ? gated("/chatbot", <ChatBot />) : null;
                if (path.includes('/delivery') && !path.includes('/entregador/')) return <Delivery key="delivery-component-only" />;
                // Se não for nenhuma rota do menu superior, mostrar Visão Geral.
                // v1.5.406: quem não tem a permissão NÃO monta a Visão Geral. Antes ela
                // montava e disparava ~10 requests pesados (/visao-geral,
                // /resumo, /relatorios de vários meses) ANTES de o guard
                // redirecionar — desperdício a cada acesso e combustível do
                // loop de redirecionamento. O guard cuida da navegação; aqui
                // só evitamos o trabalho inútil.
                if (!podeVisaoGeral) return null;
                return <VisaoGeral />;
              })()
            } />
            {/* Rotas com path explícito para capturar sub-rotas */}
            <Route path="cardapio-admin/*" element={<CardapioPublico onLoginClick={() => setActiveTopMenu(null)} />} />
            <Route path="mesas/*" element={gated("/mesas", telaMesas)} />
            <Route path="comandas/*" element={gated("/comandas", telaComandas)} />
            <Route path="balcao/*" element={gated("/balcao", telaBalcao)} />
            <Route path="totem/*" element={gated("/totem", telaTotem)} />
            <Route path="chatbot/*" element={gated("/chatbot", <ChatBot />)} />
            
            {/* Rota de Delivery com sub-rotas */}
            <Route path="delivery/*" element={
              <Routes>
                <Route path="entregador/:entregadorId" element={
                  <EntregadorDetalheWrapper setActiveTopMenu={setActiveTopMenu} usingSidebarMenuRef={usingSidebarMenuRef} />
                } />
                <Route index element={<Delivery key="delivery-component-only" />} />
                <Route path="*" element={<Delivery key="delivery-component-only" />} />
              </Routes>
            } />
            
            {/* Rotas do Menu Lateral */}
            {/* Rota de Entregador Detalhe - quando acessado via menu lateral */}
            <Route path="/entregador/:entregadorId" element={
              <EntregadorDetalheWrapper setActiveTopMenu={setActiveTopMenu} usingSidebarMenuRef={usingSidebarMenuRef} />
            } />
            {/* v1.5.406: mesma regra do `index` — sem a permissão, não monta a
                Visão Geral (o guard redireciona pra home permitida dele). */}
            <Route path="/" element={podeVisaoGeral ? <VisaoGeral /> : null} />
            <Route path="/kds" element={gated("/kds", <KDS />)} />
            {/* Ajuda: sem gated() — acessível a todo papel e plano */}
            <Route path="/ajuda" element={<AjudaPage />} />
            <Route path="/indique-e-ganhe" element={gated("/indique-e-ganhe", <IndiqueEGanhe />)} />
            <Route path="/estoque/relatorio" element={gated("/estoque/relatorio", <Reports />)} />
            <Route path="/ingredientes" element={<Ingredients />} />
            <Route path="/estoque" element={gated("/estoque", <Ingredients />)} />
            <Route path="/compras" element={gated("/compras", <Purchases />)} />
            <Route path="/compras/nova" element={gated("/compras", <NovaCompraPage />)} />
            <Route path="/compras/:loteId/editar" element={gated("/compras", <NovaCompraPage />)} />
            <Route path="/produtos" element={<Products sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} setHeaderHidden={setHeaderHidden} />} />
            <Route path="/cardapio/banners" element={<BannersPage />} />
            {/* Auditoria removida */}
            <Route path="/configuracao" element={<div className="p-8"><h1 className="text-3xl font-bold">Configuração</h1><p className="text-muted-foreground mt-2">Em breve...</p></div>} />
            {/* Rotas de Clientes e Fornecedores */}
            <Route path="/clientes-fornecedores/clientes" element={<Clientes />} />
            <Route path="/clientes-fornecedores/fornecedores" element={gated("/clientes-fornecedores/fornecedores", <Fornecedores />)} />
            <Route path="/clientes-fornecedores/funcionarios" element={<Funcionarios />} />
            {/* Rotas de Localização */}
            <Route path="/localizacao/bairros" element={<Bairros />} />
            <Route path="/localizacao/area-entrega" element={<AreaEntrega />} />
            {/* Rotas de Vendas */}
            <Route path="/vendas/relatorio" element={<RelatorioVendas defaultTab="visao-geral" />} />
            <Route path="/vendas/relatorio-produtos" element={<RelatorioVendas defaultTab="produtos" />} />
            <Route path="/vendas/relatorio-modulos" element={<RelatorioVendas defaultTab="modulos" />} />
            <Route path="/vendas/relatorio-pagamentos" element={<RelatorioVendas defaultTab="pagamentos" />} />
            <Route path="/relatorios/cardapio" element={<RelatorioCardapio />} />
            <Route path="/relatorios/categorias" element={<RelatorioCategorias />} />
            <Route path="/relatorios/tempo" element={<RelatorioTempoPage />} />
            <Route path="/relatorios/avaliacoes" element={<RelatorioAvaliacoes />} />
            <Route path="/vendas/relatorio-old" element={
              <div className="p-8">
                <div className="max-w-7xl">
                  <div className="mb-8">
                    <h1 className="text-3xl font-bold tracking-tight">Relatório de Vendas</h1>
                    <p className="text-muted-foreground mt-1">Análise de vendas e desempenho</p>
                  </div>
                  <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-2xl border border-primary/20 p-8">
                    <div className="flex items-start gap-6">
                      <div className="flex-shrink-0">
                        <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center">
                          <BarChart3 className="w-8 h-8 text-primary" strokeWidth={1.5} />
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-500/20 text-amber-700 dark:text-amber-400 rounded-full text-xs font-medium mb-3">
                          Em Desenvolvimento
                        </div>
                        <h2 className="text-xl font-bold mb-2">Em breve...</h2>
                        <p className="text-muted-foreground">
                          Esta funcionalidade está em desenvolvimento. Em breve você poderá visualizar relatórios completos de vendas.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } />
            <Route path="/vendas/pedidos" element={<Pedidos userPlan={userPlan} />} />
            <Route path="/vendas/entregas" element={<RelatorioEntregas />} />
            <Route path="/vendas/ifood" element={<IFoodConfig />} />
            <Route path="/vendas/clientes" element={
              <div className="p-8">
                <h1 className="text-3xl font-bold">Clientes</h1>
                <p className="text-muted-foreground mt-2">Em breve...</p>
                <div className="mt-8 p-6 bg-muted/50 rounded-xl border text-center">
                  <Users className="w-16 h-16 mx-auto text-muted-foreground/50 mb-4" />
                  <p className="text-muted-foreground">Esta funcionalidade está em desenvolvimento.</p>
                </div>
              </div>
            } />
            {/* Rotas de Financeiro */}
            <Route path="/financeiro/caixa" element={<Caixa caixaAberto={caixaAberto} setCaixaAberto={setCaixaAberto} onAbrirCaixa={() => setAbrirCaixaModalOpen(true)} permissoes={permissoesCaixa(canAccessModule)} />} />
            <Route path="/financeiro/extrato" element={gated("/financeiro/extrato", <ExtratoFinanceiro />)} />
            <Route path="/financeiro/despesas" element={<Despesas />} />
            {/* Nova/editar despesa em tela inteira (antes era popup dentro de Despesas) */}
            <Route path="/financeiro/despesas/nova" element={<NovaDespesaPage />} />
            <Route path="/financeiro/despesas/:id/editar" element={<NovaDespesaPage />} />
            <Route path="/financeiro/fiscal" element={<FiscalPage />} />
            <Route path="/financeiro/fluxo-caixa" element={<FluxoCaixaPage />} />
            <Route path="/financeiro/formas-pagamento" element={<FormasPagamento />} />
            <Route path="/financeiro/formas-pagamento/nova" element={<EditarFormaPage />} />
            <Route path="/financeiro/formas-pagamento/:id/editar" element={<EditarFormaPage />} />
            <Route path="/financeiro/formas-pagamento/canal/:chave" element={<EditarFormaPage />} />
            {/* Rotas de Impulsione suas Vendas */}
            <Route path="/impulsione/relatorio-ofertas" element={gated("/impulsione/relatorio-ofertas", <RelatorioOfertas />)} />
            <Route path="/impulsione/relatorio-ofertas/cashback" element={gated("/impulsione/relatorio-ofertas", <RelatorioCashback />)} />
            <Route path="/impulsione/relatorio-ofertas/cartao-fidelidade" element={gated("/impulsione/relatorio-ofertas", <RelatorioCartaoPage />)} />
            <Route path="/impulsione/relatorio-ofertas/cupons" element={gated("/impulsione/relatorio-ofertas", <RelatorioCuponsPage />)} />
            <Route path="/impulsione/relatorio-ofertas/cupons/:chave" element={gated("/impulsione/relatorio-ofertas", <CupomDetalhePage />)} />
            {/* Anúncios Meta saiu de dentro do Relatório de Ofertas (27/10/2026): o endereço antigo leva ao novo.
                Mesma trava de plano de antes. */}
            <Route path="/relatorios/anuncios-meta" element={gated("/impulsione/relatorio-ofertas", <RelatorioMetaAdsPage />)} />
            <Route path="/relatorios/anuncios-meta/:chave" element={gated("/impulsione/relatorio-ofertas", <CampanhaMetaDetalhePage />)} />
            <Route path="/impulsione/relatorio-ofertas/meta-ads" element={<Navigate to="/admin/relatorios/anuncios-meta" replace />} />
            <Route path="/impulsione/relatorio-ofertas/meta-ads/:chave" element={gated("/impulsione/relatorio-ofertas", <CampanhaMetaDetalhePage />)} />
            <Route path="/impulsione/relatorio-ofertas/promocoes" element={gated("/impulsione/relatorio-ofertas", <RelatorioPromocoesPage />)} />
            <Route path="/impulsione/relatorio-ofertas/promocoes/:chave" element={gated("/impulsione/relatorio-ofertas", <PromocaoDetalhePage />)} />
            {/* Campanha Inteligente: páginas próprias, sem trava de plano (Campanhas é de todas as lojas) */}
            <Route path="/impulsione/relatorio-ofertas/campanhas" element={gated("/impulsione/campanhas", <RelatorioCampanhas />)} />
            <Route path="/impulsione/relatorio-ofertas/campanhas/campanha-inteligente" element={gated("/impulsione/campanhas", <RelatorioCampanhaInteligentePage />)} />
            <Route path="/impulsione/campanhas/campanha-inteligente" element={gated("/impulsione/campanhas", <ConfigCampanhaInteligentePage />)} />
            <Route path="/impulsione/relatorio-ofertas/campanhas/recuperador-de-vendas" element={gated("/impulsione/campanhas", <RelatorioRecuperadorPage />)} />
            <Route path="/impulsione/campanhas/recuperador-de-vendas" element={gated("/impulsione/campanhas", <ConfigRecuperadorPage />)} />
            <Route path="/impulsione/relatorio-ofertas/campanhas/sugestoes-inteligentes" element={gated("/impulsione/campanhas", <RelatorioSugestoesPage />)} />
            {/* Endereço antigo ("Promo e Cupons") continua levando para Promoções. */}
            <Route path="/impulsione/promo-cupons" element={<Navigate to="/admin/impulsione/promocoes" replace />} />
            <Route path="/impulsione/promocoes" element={<Promocoes />} />
            <Route path="/impulsione/cupons" element={gated("/impulsione/cupons", <CuponsDesconto />)} />
            <Route path="/impulsione/campanhas" element={gated("/impulsione/campanhas", <Campanhas />)} />
            {/* Fidelize + Disparos (v1.5.466). A rota antiga de agendamentos
                continua valendo e abre Configurações → Horários na aba certa. */}
            <Route path="/impulsione/fidelize" element={<FidelizePage />} />
            <Route path="/impulsione/fidelize/cashback" element={<CashbackPage />} />
            <Route path="/impulsione/fidelize/pontuacao" element={<EmBrevePage id="pontuacao" />} />
            <Route path="/impulsione/fidelize/cartao-fidelidade" element={<CartaoFidelidadePage />} />
            <Route path="/impulsione/fidelize/roleta" element={<EmBrevePage id="roleta" />} />
            <Route path="/impulsione/disparos" element={gated("/impulsione/disparos", <DisparosPage />)} />
            <Route path="/impulsione/links" element={gated("/impulsione/links", <LinksDivulgacaoPage />)} />
            <Route path="/impulsione/anuncios-meta" element={gated("/impulsione/anuncios-meta", <AnunciosMetaPage />)} />
            <Route path="/impulsione/anuncios-meta/impulsionar" element={gated("/impulsione/anuncios-meta", <ImpulsionarPage />)} />
            <Route path="/impulsione/anuncios-meta/campanha/:campanhaId/anuncio" element={gated("/impulsione/anuncios-meta", <ImpulsionarPage />)} />
            <Route path="/impulsione/agendamentos" element={<ConfiguracaoHorarios defaultTab="agendamentos" />} />
            {/* Rotas de Configurações */}
            <Route path="/configuracoes/horarios" element={<ConfiguracaoHorarios />} />
            <Route path="/configuracoes/sistema" element={<Sistema userPlan={userPlan} />} />
            <Route path="/assinatura" element={<Assinatura />} />
          </Routes>
        </main>
      </div>

      {/* Popup de release notes — abre 1× por sessão dentro da janela do release atual.
          Config em `src/data/currentRelease.js` (id/date/version/sections/expires_at). */}
      <ReleaseNotesModal />

      {/* Modal de Histórico de Versões */}
      <Dialog open={versionDialogOpen} onOpenChange={setVersionDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Info className="w-5 h-5" />
              Histórico de Versões
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 overflow-y-auto max-h-[calc(90vh-120px)]">
            <div className="bg-muted/50 rounded-lg p-4">
              <div className="text-sm font-medium text-muted-foreground mb-1">Versão Atual</div>
              <div className="text-2xl font-bold">v{versionInfo.current}</div>
            </div>
            
            {versionInfo.history && versionInfo.history.length > 0 && (
              <div className="space-y-2">
                <div className="text-sm font-medium text-muted-foreground mb-2">Histórico de Deploys</div>
                <div className="space-y-3">
                  {versionInfo.history
                    .sort((a, b) => new Date(b.deployedAt) - new Date(a.deployedAt))
                    .map((item, index) => {
                      const deployDate = new Date(item.deployedAt);
                      const formattedDate = deployDate.toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      });
                      return (
                        <div
                          key={index}
                          className={`p-3 rounded-lg border ${
                            item.version === versionInfo.current
                              ? 'bg-primary/10 border-primary/20'
                              : 'bg-muted/30 border-border'
                          }`}
                        >
                          <div className="flex items-center justify-between mb-1">
                            <span className="font-semibold">v{item.version}</span>
                            {item.version === versionInfo.current && (
                              <span className="text-xs bg-primary text-primary-foreground px-2 py-0.5 rounded-full">
                                Atual
                              </span>
                            )}
                          </div>
                          <div className="text-xs text-muted-foreground mb-2">
                            Deploy: {formattedDate}
                          </div>
                          {(item.title || item.description) && (
                            <div className="mt-2 p-3 bg-background/50 rounded border border-border/50 space-y-2">
                              {item.title && (
                                <p className="text-sm font-medium text-foreground leading-snug">
                                  {item.title}
                                </p>
                              )}
                              {Array.isArray(item.bullets) && item.bullets.length > 0 ? (
                                <ul className="space-y-1 list-disc pl-4 marker:text-muted-foreground/60">
                                  {item.bullets.map((b, i) => (
                                    <li key={i} className="text-xs text-muted-foreground leading-relaxed">
                                      {b}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                !item.title && (
                                  <p className="text-xs text-muted-foreground whitespace-pre-line">
                                    {item.description}
                                  </p>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Caixa Aberto → navega e abre fechar */}

      <AbrirCaixaModal open={abrirCaixaModalOpen} onOpenChange={setAbrirCaixaModalOpen} onAbrir={handleAbrirCaixa} />
      <FecharCaixaModal
        open={fecharCaixaModalOpen}
        onOpenChange={setFecharCaixaModalOpen}
        caixaAberto={caixaAberto}
        onFechado={() => { setCaixaAberto(null); }}
      />

      {/* Modal Abrir Loja */}
      <Dialog open={storeOpenModalOpen} onOpenChange={setStoreOpenModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-green-600">
              <Store className="w-5 h-5" />
              Abrir Loja
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Ao abrir a loja, ela seguirá automaticamente os <strong>horários de funcionamento</strong> configurados.
            </p>
            {todayBusinessHours ? (
              <div className="bg-muted/50 rounded-lg p-4">
                <p className="text-xs font-medium text-muted-foreground mb-2">Horário de hoje ({todayBusinessHours.day_name})</p>
                {todayBusinessHours.is_open ? (
                  <div className="space-y-1">
                    <p className="text-sm font-semibold">
                      {todayBusinessHours.is_24h ? "24 horas" : `${todayBusinessHours.opening_time} - ${todayBusinessHours.closing_time}`}
                    </p>
                    {todayBusinessHours.has_second_period && !todayBusinessHours.is_24h && (
                      <p className="text-sm font-semibold">
                        {todayBusinessHours.opening_time_2} - {todayBusinessHours.closing_time_2}
                      </p>
                    )}
                    {todayBusinessHours.has_third_period && !todayBusinessHours.is_24h && (
                      <p className="text-sm font-semibold">
                        {todayBusinessHours.opening_time_3} - {todayBusinessHours.closing_time_3}
                      </p>
                    )}
                  </div>
                ) : (
                  <p className="text-sm text-red-500 font-medium">Fechado hoje (conforme horário configurado)</p>
                )}
              </div>
            ) : (
              <div className="bg-muted/50 rounded-lg p-4">
                <p className="text-sm text-muted-foreground">Nenhum horário configurado — loja ficará aberta sem restrição.</p>
              </div>
            )}
            <div className="flex gap-2 pt-2">
              <Button variant="outline" className="flex-1" onClick={() => setStoreOpenModalOpen(false)}>Cancelar</Button>
              <Button className="flex-1 bg-green-600 hover:bg-green-700 text-white" onClick={handleStoreOpen} disabled={storeToggleLoading}>
                {storeToggleLoading ? "Abrindo..." : "Abrir Loja"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Fechar Loja */}
      <Dialog open={storeCloseModalOpen} onOpenChange={setStoreCloseModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Store className="w-5 h-5" />
              Fechar Loja
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-5">
            {/* Motivo */}
            <div>
              <p className="text-sm font-medium mb-3">Motivo do fechamento</p>
              <div className="grid gap-2">
                {[
                  { value: "muitos_pedidos", label: "Muitos pedidos", icon: "📦" },
                  { value: "falta_colaboradores", label: "Falta de colaboradores", icon: "👥" },
                  { value: "outros", label: "Outros", icon: "📋" },
                ].map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => setStoreCloseReason(opt.value)}
                    className={`flex items-center gap-3 p-3 rounded-lg border text-sm text-left transition-all ${
                      storeCloseReason === opt.value
                        ? 'border-red-500 bg-red-500/10 text-foreground'
                        : 'border-border hover:bg-muted'
                    }`}
                  >
                    <span className="text-lg">{opt.icon}</span>
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Duração */}
            {storeCloseReason && (
              <div>
                <p className="text-sm font-medium mb-3">Por quanto tempo?</p>
                <div className="grid grid-cols-3 gap-2">
                  {[
                    { value: "5", label: "5 min" },
                    { value: "10", label: "10 min" },
                    { value: "15", label: "15 min" },
                    { value: "30", label: "30 min" },
                    { value: "60", label: "1 hora" },
                    { value: "120", label: "2 horas" },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      onClick={() => setStoreCloseDuration(opt.value)}
                      className={`p-2.5 rounded-lg border text-sm font-medium transition-all ${
                        storeCloseDuration === opt.value
                          ? 'border-red-500 bg-red-500/10 text-foreground'
                          : 'border-border hover:bg-muted'
                      }`}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
                <div className="grid grid-cols-2 gap-2 mt-2">
                  <button
                    onClick={() => setStoreCloseDuration("today")}
                    className={`p-2.5 rounded-lg border text-sm font-medium transition-all ${
                      storeCloseDuration === "today"
                        ? 'border-red-500 bg-red-500/10 text-foreground'
                        : 'border-border hover:bg-muted'
                    }`}
                  >
                    Só hoje
                  </button>
                  <button
                    onClick={() => setStoreCloseDuration("permanent")}
                    className={`p-2.5 rounded-lg border text-sm font-medium transition-all ${
                      storeCloseDuration === "permanent"
                        ? 'border-red-500 bg-red-500/10 text-foreground'
                        : 'border-border hover:bg-muted'
                    }`}
                  >
                    Até abrir de novo
                  </button>
                </div>
              </div>
            )}

            {/* Botões */}
            <div className="flex gap-2 pt-2">
              <Button variant="outline" className="flex-1" onClick={() => setStoreCloseModalOpen(false)}>Cancelar</Button>
              <Button
                className="flex-1 bg-red-600 hover:bg-red-700 text-white"
                onClick={handleStoreClose}
                disabled={!storeCloseReason || !storeCloseDuration || storeToggleLoading}
              >
                {storeToggleLoading ? "Fechando..." : "Fechar Loja"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
    </FiscalProvider>
  );
}
